<template>
  <!-- <div> -->
  <v-container class="rabDetailContainer">
    <v-form
      ref="entryForm"
      @submit.prevent="submitHeader()"
      lazy-validation
      :disabled="loading"
    >
      <v-btn
        type="button"
        elevation="0"
        color="black"
        class="black--text font-weight-bold fontSize12 position-relative"
        @click.prevent="close"
        :loading="loading"
        outlined
        small
      >
        <v-icon small>mdi-chevron-left</v-icon>
        Kembali
      </v-btn>
      <v-card class="card-title" tile flat>
        <div class="card-title-div1">
          <v-toolbar-title class="overline" style="position: relative">
            <p
              :style="`font-size:${wWidth > 780 ? '20px' : '3vw'}; margin: 0;`"
            >
              Detail Realisasi Anggaran Biaya
              {{ detail != null && detail.rab_type == 2 ? ' (REVISI)' : '' }}
              <v-tooltip bottom color="grey">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    text
                    icon
                    color="grey darken-2"
                    @click="getDetail"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>refresh page</span>
              </v-tooltip>
            </p>
          </v-toolbar-title>
        </div>
        <div v-if="detail != null">
          <div v-if="!isEdit" class="actionButton">
            <div v-if="detail.status.id == 0">
              <v-btn
                @click="submitRAB"
                rounded
                elevation="0"
                color="primary"
                class="white--text font-weight-bold ma-2 fontSize12"
                :loading="loading"
                small
              >
                Submit
              </v-btn>
            </div>
            <div v-if="detail.status.id == 2">
              <v-btn
                @click="takeRAB"
                rounded
                elevation="0"
                color="primary"
                class="white--text font-weight-bold ma-2 fontSize12"
                :loading="loading"
                small
              >
                Take
              </v-btn>
            </div>
            <div v-if="detail.status.id == 3">
              <v-btn
                @click="doneRAB"
                rounded
                elevation="0"
                color="success"
                class="white--text font-weight-bold ma-2 fontSize12"
                :loading="loading"
                small
              >
                Done
              </v-btn>
            </div>
            <div
              v-if="
                detail.status.id == 1 &&
                isAllow &&
                detail.approver_users.find(
                  (e) => e === getUserProfile.employee.email
                ) != undefined
              "
            >
              <v-btn
                @click="confirmRAB"
                rounded
                elevation="0"
                color="success"
                class="white--text font-weight-bold ma-2 fontSize12"
                :loading="loading"
                small
              >
                Approve
              </v-btn>
              <v-btn
                @click="rejectRAB"
                type="button"
                rounded
                elevation="0"
                color="red"
                class="white--text font-weight-bold ma-2 fontSize12"
                :loading="loading"
                small
              >
                reject
              </v-btn>
            </div>
            <!-- Cancel button -->

            <!-- <div>
                <v-dialog
                  v-if="
                    detail.status.id == 0 ||
                      detail.status.id == 2 ||
                      detail.status.id == 3
                  "
                  v-model="cancelDialog"
                  width="500"
                  persistent
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      type="button"
                      rounded
                      elevation="0"
                      color="red"
                      class="white--text font-weight-bold ma-2"
                      style="font-size:12px;"
                      :loading="loading"
                    >
                      Cancel
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Form Pembatalan
                    </v-card-title>

                    <v-card-text class="d-flex justify-center align-center">
                      <v-col
                        md="12"
                        style="padding: 0; position:relative; top:20px;"
                      >
                        <div class="vPadX0Y10">
                          <v-col cols="12" class="vPad0">
                            <p
                              class="text-left"
                              style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                            >
                              Alasan pembatalan
                            </p>
                          </v-col>
                          <v-col cols="12" style="padding: 0;">
                            <v-textarea v-model="form.cancel_reason" outlined />
                          </v-col>
                        </div>
                      </v-col>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn
                        color="error"
                        text
                        outlined
                        @click="cancelDialog = false"
                        :loading="loading"
                      >
                        Tutup
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="cancelRAB"
                        color="primary"
                        type="button"
                        text
                        outlined
                        :loading="loading"
                      >
                        Batalkan pengajuan
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div> -->
            <div v-if="detail.status.id == 5 || detail.status.id == 6">
              <v-btn
                @click="setToDraftRAB"
                rounded
                elevation="0"
                color="primary"
                class="white--text font-weight-bold ma-2 fontSize12"
                :loading="loading"
                small
              >
                Set to Draft
              </v-btn>
            </div>
            <div
              v-if="
                detail.status.id == 0 ||
                detail.status.id == 2 ||
                detail.status.id == 3
              "
            >
              <v-btn
                @click="cancelRAB"
                rounded
                elevation="0"
                color="error"
                class="white--text font-weight-bold ma-2 fontSize12"
                :loading="loading"
                small
              >
                Cancel
              </v-btn>
            </div>
          </div>
        </div>
        <div
          v-if="detail != null"
          class="d-flex justify-center align-center card-title-div2"
          :style="`${statusColor(detail.status.id)}`"
        >
          <p class="card-title-div2-name">
            {{ detail.status.name }}
          </p>
        </div>
      </v-card>

      <v-card class="card-content" v-if="detail != null" elevation="0">
        <v-toolbar-title class="toolbarTitle">
          <!-- <p
              v-if="detail.budget_no != null"
              style="font-size: 20px; margin: 0; font-weight: bold; color:indigo;position:relative;"
            >
              {{ detail.budget_no }}
            </p> -->

          <div class="d-flex justify-start align-center toolbarTitleDate">
            <p class="date1">
              Tgl. Buat :
              {{ detail.created_at }}/{{ detail.created_by_name }}
            </p>
            <p class="date1">
              Tgl. Submit :
              {{ detail.submited_at }}/{{ detail.submited_by_name }}
            </p>
            <p class="date2">
              Tgl. Terima :
              {{ detail.received_at }}/{{ detail.received_by_name }}
            </p>
          </div>

          <div
            v-if="detail.status.id == 0 && detail.rab_type != 2"
            class="d-flex toolbarHeaderButton"
          >
            <v-btn
              v-if="!isEdit"
              @click.prevent="editHeader()"
              type="button"
              text
              small
              elevation="0"
              color="primary"
              class="white--text font-weight-bold fontSize12"
              :loading="loading"
            >
              <v-icon small>mdi-pencil</v-icon>
              Edit Header
            </v-btn>

            <v-btn
              v-if="isEdit"
              type="submit"
              small
              text
              outlined
              elevation="0"
              color="success"
              class="white--text font-weight-bold fs12ml15"
              :loading="loading"
            >
              <v-icon small>mdi-save</v-icon>
              Simpan
            </v-btn>
            <v-btn
              v-if="isEdit"
              @click="cancelHeader"
              small
              text
              outlined
              type="button"
              elevation="0"
              color="error"
              class="white--text font-weight-bold fs12ml10"
              :loading="loading"
            >
              Batal
            </v-btn>
          </div>
        </v-toolbar-title>
        <v-row class="rowPaddingY15" no-gutters>
          <v-col cols="12" class="vPad0">
            <v-row class="vPad10">
              <v-col cols="3">
                <v-card elevation="1" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="mb-2 prwidh120">
                        <span class="text-overline"> Total Item</span>
                        <div class="totalItemBudgetInfo">
                          (dengan budget terisi)
                        </div>
                      </div>
                      <v-list-item-title class="text-h5">
                        {{ getQtyWithBudgetFilled() }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card elevation="1" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="text-overline mb-2">Total Budget</div>
                      <v-list-item-title class="text-h5">
                        {{ priceConvert(detail.total_budget_plan) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card elevation="1" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="text-overline mb-2">Total Realisasi</div>
                      <v-list-item-title
                        class="text-h5 d-flex justify-start align-end position-relative"
                      >
                        <div>{{ percentConvert(detail) }}%</div>
                        <div class="fs12ml15">
                          ({{ priceConvert(0) }}/{{
                            priceConvert(detail.total_budget_plan)
                          }})<span style="font-size: 10px">(coming soon)</span>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">No. RAB</p>
              </v-col>
              <v-col cols="12" class="vPadMt6">
                <v-text-field dense :value="detail.budget_no" readonly />
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Nama RAB</p>
              </v-col>
              <v-col cols="12" class="xP0Mt6half">
                <v-text-field
                  v-model="detail.name"
                  dense
                  :outlined="isEdit"
                  :readonly="!isEdit"
                />
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="3" class="vPad0"></v-col>
          <v-col cols="12" md="3" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Kategori</p>
              </v-col>
              <v-col cols="12" class="xP0Mt6half">
                <v-autocomplete
                  v-model="detail.budget_category"
                  :items="dropdown.categoryPr"
                  :outlined="isEdit"
                  :readonly="!isEdit"
                  :clearable="isEdit"
                  item-text="name"
                  item-value="id"
                  return-id
                  dense
                  class="xMargin"
                ></v-autocomplete>
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="vPadProjectTitle">Project</p>
              </v-col>
              <v-col cols="12" class="vPadMt6">
                <v-text-field
                  v-if="!isEdit"
                  dense
                  :value="
                    detail.project != null
                      ? `(${detail.project.code}) ${detail.project.name}`
                      : ''
                  "
                  readonly
                />
                <v-autocomplete
                  v-else
                  v-model="detail.project"
                  :items="dropdown.project"
                  item-text="name"
                  item-value="id"
                  return-object
                  outlined
                  dense
                  class="xMargin"
                  clearable
                ></v-autocomplete>
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="3" class="vPad0"></v-col>

          <v-col cols="12" md="3" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Perusahaan</p>
              </v-col>
              <v-col cols="12" class="xP0Mt4">
                <v-text-field dense :value="detail.company.name" readonly />
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="3" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Department</p>
              </v-col>
              <v-col cols="12" class="xP0Mt4">
                <v-text-field dense :value="detail.department.name" readonly />
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="3" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Penanggung Jawab</p>
              </v-col>
              <v-col cols="12" class="vPadMt6">
                <v-text-field
                  dense
                  :value="detail.pic_employee.name"
                  readonly
                />
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="9" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Catatan</p>
              </v-col>
              <v-col cols="12" class="vPadMt6">
                <v-textarea
                  v-model="detail.note"
                  no-resize
                  :outlined="isEdit"
                  rows="2"
                  auto-grow
                  dense
                  :readonly="!isEdit"
                />
              </v-col>
            </div>
          </v-col>

          <v-col v-if="detail.cancel_reason" cols="12" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Alasan Cancel</p>
              </v-col>
              <v-col cols="12" class="xP0Mt4">
                <v-textarea
                  :value="`[${detail.cancel_by_name}| ${detail.cancel_at}]\n${detail.cancel_reason}`"
                  no-resize
                  outlined
                  rows="2"
                  dense
                  readonly
                />
              </v-col>
            </div>
          </v-col>
          <!-- <v-col v-if="detail.status.id == 6" cols="12" class="vPad0">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p class="xLabelName">Alasan Reject</p>
              </v-col>
              <v-col cols="12" class="xP0Mt4">
                <v-textarea
                  :value="`${detail.reject_reason}`"
                  no-resize
                  outlined
                  rows="2"
                  dense
                  readonly
                />
              </v-col>
            </div>
          </v-col> -->
          <v-col cols="12" class="rowColTable">
            <v-data-table
              v-if="detail != null"
              v-model="selectedData"
              @click:row="rowClick"
              :search="searchItem"
              :headers="headers"
              :items="detail.budget_plan_detail"
              :items-per-page="10"
              :loading="loading"
              :show-select="
                getUserProfile.level.find(({ id }) => id == '41') ==
                  undefined &&
                detail.status.id == 3 &&
                detail.rab_type != 2
              "
              :custom-filter="customSearch"
              mobile-breakpoint="0"
              class="elevation-1 xTableBorderNCursor"
              item-key="id"
            >
              <template v-slot:top>
                <div class="xTableTopSlot">
                  <div class="topSlotButton">
                    <v-btn
                      v-if="detail.status.id == 0 && detail.rab_type != 2"
                      elevation="1"
                      color="primary"
                      type="button"
                      small
                      class="white--text font-weight-bold mb-2 mr-3"
                      :loading="loading"
                      @click="openRabItemDialog('add')"
                      :disabled="isEdit"
                    >
                      + Barang
                    </v-btn>
                    <div v-if="detail.status.id == 3 && detail.rab_type != 2">
                      <v-btn
                        v-if="selectedData.length > 0"
                        elevation="1"
                        color="primary"
                        type="button"
                        small
                        class="white--text font-weight-bold xMargin00310"
                        @click="createFPB"
                        :loading="loading"
                        :disabled="isEdit"
                      >
                        + FPB
                      </v-btn>
                    </div>
                  </div>
                  <div class="topSlotSearch">
                    <v-text-field
                      v-model="searchItem"
                      outlined
                      label="Cari barang"
                      dense
                    ></v-text-field>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="d-flex align-center">
                    <v-btn
                      elevation="0"
                      color="transparent"
                      small
                      outlined
                      class="xMr10"
                      :loading="loading"
                      @click="downloadDokumen"
                    >
                      <v-icon color="primary" small class="xMr5"
                        >mdi-file-outline</v-icon
                      >
                      <a href="#" class="font-weight-bold">Lihat Dokumen</a>
                    </v-btn>
                    <v-btn
                      elevation="0"
                      color="transparent"
                      small
                      outlined
                      class="xMr10"
                      :loading="loading"
                      @click="generatePdfRAB"
                    >
                      <v-icon color="primary" small class="xMr5"
                        >mdi-magnify
                      </v-icon>
                      <a href="#" class="font-weight-bold">Lihat RAB</a>
                    </v-btn>
                  </div>
                </div>
              </template>
              <template v-slot:[`item.no`]="{ index }">
                <td>
                  {{ index + 1 }}
                </td>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div class="d-flex xWidth50" v-if="detail.rab_type != 2">
                  <v-btn
                    @click.stop="deleteItem(item)"
                    type="button"
                    rounded
                    x-small
                    icon
                    elevation="0"
                    color="red"
                    class="white--text font-weight-bold ma-2"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.product.code`]="{ item }">
                <div class="d-flex xWidth60">
                  <p style="margin: 0; font-size: 12px">
                    {{ item.product.code }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.product.name`]="{ item }">
                <div class="d-flex xWidth150">
                  <p style="margin: 0; font-size: 12px">
                    {{ item.product.name }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.category`]="{ item }">
                <div class="d-flex xWidth70">
                  <p style="margin: 0; font-size: 12px">
                    {{ item.category != null ? item.category.name : '' }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.vendor_recomendation`]="{ item }">
                <div class="d-flex xWidth150">
                  <!-- <p
                    v-if="item.product.code != null"
                    style="margin: 0; font-size: 12px"
                  >
                    {{ item.vendor.name }}
                  </p> -->
                  <p style="margin: 0; font-size: 12px">
                    {{
                      item.vendor_recomendation != null
                        ? item.vendor_recomendation.name
                        : ''
                    }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.estimate_date_use`]="{ item }">
                <div class="d-flex xWidth70">
                  <p style="margin: 0; font-size: 12px">
                    {{ item.estimate_date_use }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.qty`]="{ item }">
                <div class="d-flex xWidth50">
                  <p style="margin: 0; font-size: 12px">{{ item.qty }}</p>
                </div>
              </template>
              <template v-slot:[`item.fpb_qty`]="{ item }">
                <v-tooltip top color="white">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="d-flex xWidth50">
                      <p style="margin: 0; font-size: 12px">
                        {{ item.qty - item.qty_remain }}
                      </p>
                    </div>
                  </template>
                  <div
                    class="itemFpbQtySlot"
                    v-if="
                      item.purchase_request_detail != null &&
                      item.purchase_request_detail.length > 0
                    "
                  >
                    <div
                      v-for="(obj, idx) in item.purchase_request_detail"
                      :key="idx"
                    >
                      <v-chip
                        label
                        small
                        class="fpbNoChip"
                        color="primary"
                        v-if="
                          obj.purchase_request != null &&
                          obj.purchase_request.stt != 4
                        "
                      >
                        {{ obj.purchase_request.no }}
                      </v-chip>
                    </div>
                  </div>

                  <div
                    class="itemFpbQtySlot"
                    v-if="item.deviation_fpb_item != null"
                  >
                    <v-chip
                      label
                      small
                      class="fpbNoChip"
                      color="primary"
                      v-if="item.deviation_fpb_item.purchase_request != null"
                    >
                      {{ item.deviation_fpb_item.purchase_request.no }}
                    </v-chip>
                  </div>
                </v-tooltip>
              </template>
              <template v-slot:[`item.qty_remain`]="{ item }">
                <div class="d-flex xWidth50">
                  <p style="margin: 0; font-size: 12px">
                    {{ item.qty_remain }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.budget_price_per_unit`]="{ item }">
                <div style="width: 100px" class="d-flex">
                  <p style="margin: 0; font-size: 12px">
                    {{
                      item.currency != null && item.currency.symbol != null
                        ? `${item.currency.symbol}. `
                        : ''
                    }}{{ priceConvert(item.budget_price_per_unit) }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.budget_price_total`]="{ item }">
                <div style="width: 100px" class="d-flex">
                  <p style="margin: 0; font-size: 12px">
                    {{
                      item.currency != null && item.currency.symbol != null
                        ? `${item.currency.symbol}. `
                        : ''
                    }}{{ priceConvert(item.budget_price_total) }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.rab_origin`]="{ item }">
                <div class="d-flex overflow-auto xWidth120">
                  <p style="margin: 0; font-size: 12px">
                    {{
                      item.rab_origin != null
                        ? item.rab_origin.document_no
                        : '-'
                    }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.fpb_ids`]="{ item }">
                <div
                  class="d-flex overflow-auto xWidth120"
                  v-if="
                    item.deviation_fpb_item != null &&
                    item.deviation_fpb_item.purchase_request != null
                  "
                >
                  <p style="margin: 0; font-size: 12px">
                    {{ item.deviation_fpb_item.purchase_request.no }}
                  </p>
                </div>
              </template>
              <template v-slot:[`footer.prepend`]>
                <div class="topSlotButton">
                  <v-btn
                    v-if="detail.status.id == 0 && detail.rab_type != 2"
                    elevation="1"
                    color="primary"
                    type="button"
                    small
                    class="white--text font-weight-bold mb-2 mr-3 ml-3"
                    :loading="loading"
                    @click="openRabItemDialog('add')"
                    :disabled="isEdit"
                  >
                    + Barang
                  </v-btn>
                  <div v-if="detail.status.id == 3">
                    <v-btn
                      v-if="selectedData.length > 0"
                      elevation="1"
                      color="primary"
                      type="button"
                      small
                      class="white--text font-weight-bold xMargin00310"
                      @click="createFPB"
                      :loading="loading"
                      :disabled="isEdit"
                    >
                      + FPB
                    </v-btn>
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <div class="items-total-div-1">
              <div class="items-total-div-2">
                <v-card elevation="1" class="items-total-box">
                  <p style="margin-right: auto; font-weight: bold">
                    TOTAL PENGAJUAN
                  </p>
                  <div>
                    <p>Total Qty<span>:</span></p>
                    <p style="text-align: right; width: 100%">
                      {{ detail.total_plan_qty }}
                    </p>
                  </div>
                  <div>
                    <p>Total Harga <span>:</span></p>
                    <p style="text-align: right; width: 100%">
                      {{ priceConvert(detail.total_budget_plan) }}
                    </p>
                  </div>
                </v-card>
              </div>
            </div>
          </v-col>

          <v-col cols="12" style="padding: 10px">
            <div
              style="
                color: #4e4e4e;
                margin-left: 5px;
                font-weight: bold;
                margin-bottom: 10px;
                border-bottom: 1px solid #a1a1a1;
              "
            >
              FPB LIST
            </div>
            <v-data-table
              :headers="fpbHeaders"
              :search="searchFpb"
              @click:row="openDetailFpb"
              :items="fpbResult"
              :items-per-page="10"
              mobile-breakpoint="0"
              class="elevation-1 mx-auto xTableBorderNCursor"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchFpb"
                  label="Cari FPB"
                  class="mx-4"
                  style="width: 310px"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" style="padding: 10px; margin-top: 20px">
            <!-- :loading="matrix.length === 0" -->
            <div
              style="
                color: #4e4e4e;
                margin-left: 5px;
                font-weight: bold;
                margin-bottom: 10px;
                border-bottom: 1px solid #a1a1a1;
              "
            >
              APPROVAL MATRIX
            </div>

            <v-data-table
              v-if="detail.approval_matrix != null"
              mobile-breakpoint="0"
              :headers="approvalHeaders"
              :items="detail.approval_matrix"
              :items-per-page="10"
              class="elevation-1 mx-auto"
              hide-default-footer
            >
              <template v-slot:[`item.document_no`]="{ item }">
                <div style="width: 140px; font-size: 12px">
                  {{ item.document_no }}
                </div>
              </template>
              <template v-slot:[`item.table_name`]="{ item }">
                <div style="width: 140px; font-size: 12px">
                  {{ item.table_name }}
                </div>
              </template>
              <template v-slot:[`item.approver_user`]="{ item }">
                <div style="cursor: pointer" v-if="item">
                  <v-chip
                    label
                    outlined
                    small
                    style="
                      margin-right: 5px;
                      padding: 0 3px;
                      cursor: pointer;
                      border: 1px solid rgba(0, 0, 0, 0.5);
                    "
                    v-for="(item, index) in item.approver_user"
                    :key="index"
                  >
                    {{ item.user != null ? item.user.name : '-' }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:[`item.approved`]="{ item }">
                <div
                  v-for="(items, index) in item.approver_user"
                  :key="index"
                  style="width: 140px"
                >
                  <v-chip
                    v-if="items.status == 1"
                    label
                    outlined
                    small
                    style="
                      position: relative;
                      margin-right: 5px;
                      padding: 0 3px;
                      cursor: pointer;
                      border: 1px solid rgba(0, 0, 0, 0.5);
                    "
                  >
                    {{ items.user != null ? items.user.name : '-' }}
                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ attrs, on }">
                        <div
                          v-if="items.note"
                          v-bind="attrs"
                          v-on="on"
                          @click="openCommentDialog(items)"
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 20px;
                            bottom: 0;
                            background: white;
                          "
                        >
                          <v-icon small color="info">mdi-comment-alert</v-icon>
                        </div>
                      </template>
                      <span>Klik untuk melihat catatan</span>
                    </v-tooltip>
                  </v-chip>
                </div>
              </template>
              <template v-slot:[`item.rejected`]="{ item }">
                <div
                  v-for="(items, index) in item.approver_user"
                  :key="index"
                  style="width: 240px"
                >
                  <v-chip
                    v-if="items.status == -1"
                    label
                    outlined
                    small
                    style="margin-right: 5px; padding: 0 3px; cursor: pointer"
                  >
                    <span>
                      {{ items.user != null ? items.user.name : '-' }}
                    </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <div
                          v-if="items.note"
                          v-bind="attrs"
                          v-on="on"
                          @click="openCommentDialog(items)"
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 20px;
                            bottom: 0;
                            background: white;
                          "
                        >
                          <v-icon small color="info">mdi-comment-alert</v-icon>
                        </div>
                      </template>
                      <span>Klik untuk melihat catatan</span>
                    </v-tooltip>
                  </v-chip>
                </div>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                <div style="width: 140px; font-size: 12px">
                  {{ item.created_at }}
                </div>
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                <div
                  v-for="(items, index) in item.approver_user"
                  :key="index"
                  style="width: 140px; font-size: 12px"
                >
                  <span v-if="items.status == 1">
                    {{ items.updated_at != null ? items.updated_at : '-' }}
                  </span>
                  <br v-if="index > 0" />
                </div>
              </template>
            </v-data-table>
            <div
              v-if="
                getUserProfile.level.find(({ id }) => id === '41') === undefined
              "
            >
              <div
                style="text-align: left; padding-left: 5px"
                v-if="detail.status.id === 1"
              >
                <v-btn
                  v-if="
                    getUserProfile.level.find(
                      ({ id }) => id === '1' || id === '26' || id === '30'
                    ) !== undefined
                  "
                  color="grey"
                  tile
                  dark
                  small
                  dense
                  style="font-size: 10px; width: 100px"
                  @click="checkBeforeFetch"
                  :loading="loading"
                >
                  <span>Fetch Matrix</span>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-form>

    <v-dialog v-model="rabDialog" width="800" persistent>
      <!-- :readonly="detail.status.id != 0" -->
      <!-- :disabled="
        getUserProfile.level.find(({ id }) => id == '41') != undefined
      " -->
      <v-form
        v-if="detail != null"
        @submit.prevent="submitItem"
        lazy-validation
        ref="entryFormItem"
        style="position: relative"
        :disabled="detail.status.id != 0 || detail.rab_type == 2"
        @keydown.enter.prevent
      >
        <v-card>
          <v-card-title class="text-h5 white lighten-2">
            <p style="margin: auto">TAMBAH/EDIT BARANG</p>
          </v-card-title>

          <v-card-text v-if="formItem != null" class="d-flex">
            <div style="padding: 0; position: relative; top: 20px">
              <div class="vPadX0Y10">
                <v-row>
                  <v-col
                    cols="12"
                    style="
                      padding: 0 0 0 15px;
                      display: flex;
                      justify-content: start;
                      align-items: center;
                      margin-bottom: 10px;
                    "
                  >
                    <v-col
                      cols="7"
                      style="
                        padding: 0;
                        justify-content: flex-start;
                        align-items: center;
                        display: flex;
                      "
                    >
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Cari barang dari katalog ?
                      </p>
                      <v-checkbox
                        v-model="formItem.search_from_ecatalogue"
                        :false-value="false"
                        :true-value="true"
                        style="margin: 0 0 0 10px; height: 25px; padding: 0"
                        :disabled="
                          formItem.act == 'update' ||
                          detail.budget_category != 'project'
                        "
                      ></v-checkbox>
                    </v-col>
                  </v-col>
                  <v-col cols="8">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Nama Barang *
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <div v-if="formItem.search_from_ecatalogue">
                            <v-autocomplete
                              v-if="formItem.act == 'add'"
                              v-model="selectedItem"
                              :items="catalogueItems"
                              :filter="customFilter"
                              clearable
                              outlined
                              item-text="product.name"
                              item-value="id"
                              hide-details
                              hide-no-data
                              return-object
                              label=""
                              :loading="loading"
                              :search-input.sync="searchCatalogue"
                              style="margin: 0"
                              dense
                              @keydown.enter.prevent="
                                enterSearch(searchCatalogue)
                              "
                              :rules="rules.nameRules"
                            >
                              <template v-slot:prepend-item>
                                <div
                                  style="
                                    padding: 0 15px;
                                    position: sticky;
                                    top: 0;
                                    z-index: 2;
                                  "
                                >
                                  <div
                                    style="
                                      padding: 0 25px;
                                      height: 25px;
                                      background: black;
                                      color: white;
                                      border: 2px solid black;
                                      display: flex;
                                      justify-content: flex-start;
                                      align-items: center;
                                    "
                                  >
                                    <v-toolbar-title
                                      style="
                                        text-align: left;
                                        font-size: 14px;
                                        padding: 0;
                                        width: 200px;
                                      "
                                    >
                                      Item Name
                                    </v-toolbar-title>
                                    <v-divider
                                      class="mx-3"
                                      inset
                                      vertical
                                    ></v-divider>
                                    <v-toolbar-title
                                      style="
                                        text-align: left;
                                        font-size: 14px;
                                        padding: 0;
                                        width: 120px;
                                      "
                                    >
                                      Item Code
                                    </v-toolbar-title>

                                    <v-divider
                                      class="mx-3"
                                      inset
                                      vertical
                                    ></v-divider>

                                    <v-toolbar-title
                                      style="
                                        text-align: left;
                                        font-size: 14px;
                                        padding: 0;
                                        width: 200px;
                                      "
                                    >
                                      Supplier Name
                                    </v-toolbar-title>

                                    <v-divider
                                      class="mx-3"
                                      inset
                                      vertical
                                    ></v-divider>

                                    <v-toolbar-title
                                      style="
                                        text-align: left;
                                        font-size: 14px;
                                        padding: 0;
                                        width: 120px;
                                      "
                                    >
                                      Supplier code
                                    </v-toolbar-title>
                                  </div>
                                </div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-card
                                  rounded
                                  color="transparent"
                                  style="
                                    display: flex;
                                    justify-content: flex-start;
                                    align-items: center;
                                    width: 800px;
                                    padding: 7px;
                                  "
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-toolbar-title
                                        v-bind="attrs"
                                        v-on="on"
                                        style="
                                          text-align: left;
                                          font-size: 14px;
                                          padding: 0;
                                          width: 200px;
                                        "
                                      >
                                        {{ item.product.name }}
                                      </v-toolbar-title>
                                    </template>
                                    <span>{{ item.product.name }}</span>
                                  </v-tooltip>
                                  <v-divider
                                    class="mx-3"
                                    inset
                                    vertical
                                  ></v-divider>
                                  <v-toolbar-title
                                    style="
                                      text-align: left;
                                      font-size: 14px;
                                      padding: 0;
                                      width: 120px;
                                    "
                                  >
                                    #{{ item.product.code }}
                                  </v-toolbar-title>

                                  <v-divider
                                    class="mx-3"
                                    inset
                                    vertical
                                  ></v-divider>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-toolbar-title
                                        v-bind="attrs"
                                        v-on="on"
                                        style="
                                          text-align: left;
                                          font-size: 14px;
                                          padding: 0;
                                          width: 200px;
                                        "
                                      >
                                        {{
                                          item.vendor.name != null
                                            ? item.vendor.name
                                            : ''
                                        }}
                                      </v-toolbar-title>
                                    </template>
                                    <span>{{
                                      item.vendor.name != null
                                        ? item.vendor.name
                                        : ''
                                    }}</span>
                                  </v-tooltip>

                                  <v-divider
                                    class="mx-3"
                                    inset
                                    vertical
                                  ></v-divider>

                                  <v-toolbar-title
                                    style="
                                      text-align: left;
                                      font-size: 14px;
                                      padding: 0;
                                      width: 120px;
                                    "
                                  >
                                    #{{
                                      item.vendor.code != null
                                        ? item.vendor.code
                                        : ''
                                    }}
                                  </v-toolbar-title>
                                </v-card>
                              </template>
                            </v-autocomplete>
                            <v-text-field
                              v-else
                              v-model="formItem.product.name"
                              outlined
                              readonly
                              dense
                              :rules="rules.nameRules"
                            ></v-text-field>
                          </div>
                          <v-text-field
                            v-else
                            @keydown.enter.prevent
                            v-model="formItem.product_name"
                            outlined
                            dense
                            :rules="rules.nameRules"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Kategori
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div
                          v-if="formItem.act == 'update'"
                          style="height: 41px"
                        >
                          <v-text-field
                            v-if="formItem.product.id != null"
                            v-model="formItem.category.name"
                            outlined
                            dense
                            readonly
                          ></v-text-field>
                          <v-autocomplete
                            v-else
                            v-model="formItem.category"
                            :items="dropdown.category"
                            item-text="name"
                            item-value="id"
                            return-object
                            outlined
                            dense
                            clearable
                            :rules="rules.categoryRules"
                          ></v-autocomplete>
                        </div>

                        <div v-else style="height: 41px">
                          <v-autocomplete
                            v-model="formItem.category"
                            :items="dropdown.category"
                            item-text="name"
                            item-value="id"
                            return-object
                            outlined
                            dense
                            clearable
                            :rules="rules.categoryRules"
                          ></v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Vendor Katalog
                        </p>
                      </v-col>

                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            :value="
                              formItem.vendor != null &&
                              formItem.vendor.code != null &&
                              formItem.vendor.name != null
                                ? `(${formItem.vendor.code}) ${formItem.vendor.name}`
                                : null
                            "
                            outlined
                            dense
                            disabled
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Judul Pekerjaan
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.section_title"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="4">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Material
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.material"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Dimensi
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.dimension"
                            outlined
                            dense
                          ></v-text-field>
                        </div> </v-col
                    ></v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Merk
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.merk"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="4">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Foto/Link
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.photo"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="8">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tipe
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.type"
                            outlined
                            dense
                          ></v-text-field>
                        </div> </v-col
                    ></v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Deskripsi
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-textarea
                            v-model="formItem.description"
                            rows="1"
                            outlined
                            dense
                          ></v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          qty *
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.qty"
                            type="number"
                            min="0"
                            outlined
                            dense
                            :rules="rules.qtyRules"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Satuan *
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-autocomplete
                            v-model="formItem.uom"
                            :items="dropdown.uom"
                            item-text="name"
                            item-value="id"
                            return-object
                            outlined
                            dense
                            clearable
                            :disabled="formItem.search_from_ecatalogue"
                            :rules="rules.uomRules"
                          ></v-autocomplete>
                        </div> </v-col
                    ></v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Budget Satuan *
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.budget_price_per_unit"
                            type="double"
                            outlined
                            dense
                            :rules="rules.budgetRules"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Total Harga
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-if="formItem.act == 'update'"
                            :value="itemEdit.budget_price_total"
                            type="double"
                            readonly
                            outlined
                            dense
                          ></v-text-field>
                          <v-text-field
                            v-else
                            :value="
                              formItem.budget_price_per_unit * formItem.qty
                            "
                            readonly
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Currency
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-autocomplete
                            v-model="formItem.currency"
                            :items="dropdown.currency"
                            item-text="symbol"
                            item-value="id"
                            return-object
                            outlined
                            dense
                            clearable
                          ></v-autocomplete>
                        </div> </v-col
                    ></v-row>
                  </v-col>

                  <v-col cols="4">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl. Pemakaian
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-text-field
                            v-model="formItem.estimate_date_use"
                            dense
                            type="date"
                            name="startdate"
                            step="1"
                            outlined
                            clearable
                            :rules="rules.estimateDateRules"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Referensi Vendor *
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div style="height: 41px">
                          <v-autocomplete
                            v-model="formItem.vendor_recomendation"
                            :items="dropdown.vendor"
                            :label="
                              formItem.vendor_recomendation != null
                                ? formItem.vendor_recomendation.name
                                : ''
                            "
                            clearable
                            outlined
                            item-text="name"
                            item-value="id"
                            hide-details
                            hide-no-data
                            return-object
                            :loading="loading"
                            :search-input.sync="searchVendor"
                            style="margin: 0"
                            dense
                            @keydown.enter.prevent="vendorSearch(searchVendor)"
                            :rules="rules.vendorRules"
                          >
                          </v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12" class="vPad0">
                        <p
                          style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                        >
                          Keterangan Tambahan
                        </p>
                      </v-col>
                      <v-col cols="12" class="vPad0">
                        <div>
                          <v-textarea outlined dense></v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col> -->
                </v-row>
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              type="button"
              @click="closeRabItemDialog"
              :loading="loading"
            >
              Tutup
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="detail.status.id == 0 && detail.rab_type != 2"
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="createFpbDialog" full-screen persistent>
      <v-form
        v-if="detail != null"
        ref="entryFormFpb"
        @submit.prevent="checkBeforeSubmitFpb"
        :disabled="detail.rab_type == 2"
      >
        <v-card style="padding: 10px">
          <v-card-title class="text-h5 grey lighten-2">
            BUAT FPB DARI ITEM DIBAWAH INI
          </v-card-title>
          <v-card-text
            class="d-flex justify-center align-center"
            style="padding: 10px 20px"
          >
            <v-row no-gutters>
              <v-col cols="3" style="padding: 0; margin-top: 10px">
                <div class="vPadX0Y10">
                  <v-select
                    label="Kategori PR"
                    style="
                      position: relative;
                      top: 15px;
                      margin: 0 15px 0 0;
                      font-size: 12px;
                      width: 220px;
                    "
                    v-model="formFpb.category_pr"
                    :items="dropdown.categoryPr"
                    :item-disabled="disablePrCategory"
                    @change="prCategoryWatcher"
                    item-text="name"
                    item-value="id"
                    return-id
                    outlined
                    dense
                    :rules="rules.prRules"
                    readonly
                  ></v-select>
                </div>
              </v-col>
              <v-col cols="3" style="padding: 0; margin-top: 10px">
                <div class="vPadX0Y10">
                  <v-select
                    label="Kategori Barang"
                    style="
                      position: relative;
                      top: 15px;
                      margin: 0 15px 0 0;
                      font-size: 12px;
                      width: 220px;
                    "
                    v-model="formFpb.category_item"
                    :items="dropdown.categoryItem"
                    @change="itemCategoryWatcher"
                    :item-disabled="disableCategoryItem"
                    item-text="name"
                    item-value="id"
                    return-id
                    outlined
                    dense
                    :rules="rules.itemRules"
                  ></v-select>
                  <!-- :readonly="detail.project != null" -->
                </div>
              </v-col>
              <v-col cols="12" style="padding: 0; margin-top: 10px">
                <v-data-table
                  :headers="selectedItemHeader"
                  :items="selectedData"
                  :items-per-page="10"
                  :loading="loading"
                  mobile-breakpoint="0"
                  style="border: 1px solid rgba(0, 0, 0, 0.2)"
                >
                  <template v-slot:[`item.no`]="{ index }">
                    <td>
                      {{ index + 1 }}
                    </td>
                  </template>
                  <template v-slot:[`item.product.code`]="{ item }">
                    <div class="d-flex xWidth60">
                      <p style="margin: 0; font-size: 12px">
                        {{ item.product.code }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.product.name`]="{ item }">
                    <div class="d-flex xWidth150">
                      <p style="margin: 0; font-size: 12px">
                        {{ item.product.name }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.estimate_date_use`]="{ item }">
                    <div class="d-flex xWidth70">
                      <p style="margin: 0; font-size: 12px">
                        {{ item.estimate_date_use }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.qty_remain`]="{ item }">
                    <div class="d-flex xWidth50">
                      <p style="margin: 0; font-size: 12px">
                        {{ item.qty_remain }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.qty_fpb`]="{ item }">
                    <div style="width: 80px; height: 45px" class="d-flex">
                      <v-text-field
                        v-model="item.qty_fpb"
                        autofocus
                        dense
                        small
                        type="number"
                        min="1"
                        class="fontSize12"
                        single-line
                        :rules="rules.qtyRules"
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.budget_price_per_unit`]="{ item }">
                    <div style="width: 100px" class="d-flex">
                      <p style="margin: 0; font-size: 12px">
                        {{
                          item.currency != null && item.currency.symbol != null
                            ? `${item.currency.symbol}. `
                            : ''
                        }}{{ priceConvert(item.budget_price_per_unit) }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.budget_price_total`]="{ item }">
                    <div style="width: 100px" class="d-flex">
                      <p style="margin: 0; font-size: 12px">
                        {{
                          item.currency != null && item.currency.symbol != null
                            ? `${item.currency.symbol}. `
                            : ''
                        }}{{ priceConvert(item.budget_price_total) }}
                      </p>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              type="reset"
              @click="closeFpbDialog"
              :loading="loading"
            >
              Tutup
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="detail.rab_type != 2"
              color="primary"
              type="submit"
              text
              outlined
              :loading="loading"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="commentDialog" width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Catatan Approval
        </v-card-title>

        <v-card-text class="d-flex justify-center align-center">
          <v-col md="12" style="padding: 0; position: relative; top: 20px">
            <div class="vPadX0Y10">
              <v-col cols="12" class="vPad0">
                <p style="margin: 0; font-weight: bold" v-if="comment != null">
                  {{ comment.note }}
                </p>
              </v-col>
            </div>
          </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="error" text outlined @click="closeCommentDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="detail != null"
      v-model="dokumenDialog"
      width="500"
      persistent
    >
      <v-card style="position: relative">
        <v-card-title class="text-h5 grey lighten-2">
          Dokumen Pendukung
        </v-card-title>
        <v-card-text class="d-flex justify-center align-center">
          <v-col md="12" style="padding: 0; position: relative; top: 20px">
            <v-data-table
              v-if="detail.file != null"
              mobile-breakpoint="0"
              fixed-header
              height="300"
              style="cursor: pointer"
              :headers="dokumenHeaders"
              :items="detail.file"
              @click:row="readyToDownload"
              :items-per-page="10"
            >
              <template v-slot:[`item.subject`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{
                    item.subject != null
                      ? item.subject != ''
                        ? item.subject
                        : '-'
                      : '-'
                  }}
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  <v-btn
                    v-if="getUserProfile.employee.id == detail.employee.id"
                    icon
                    x-small
                    @click.stop="
                      unlinkDokumen(
                        item.file.slice(item.file.lastIndexOf('/') + 1)
                      )
                    "
                    class="xMr5"
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click.stop="readyToDownload(item)">
                    <v-icon color="green">mdi-download</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>

            <!-- v-if="
              (getUserProfile.level.find(({ id }) => id === '41') ===
                undefined &&
                getUserProfile.employee.id === detail.employee.id) ||
              getUserProfile.employee.email === 'procurement@sanqua.co.id'
            " -->
            <v-btn
              elevation="0"
              style="margin-right: auto; width: 100%"
              :loading="loading"
              color="primary"
              @click="uploadDoc('upload')"
            >
              <v-icon small class="xMr5">mdi-upload</v-icon>
              <span :style="`font-weight: bold; color:white;`"
                >Tambah Dokumen</span
              >
            </v-btn>
          </v-col>
        </v-card-text>
        <!-- <v-btn icon color="black" text @click="closeDokumenDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="error"
            text
            outlined
            @click="closeDokumenDialog"
            :loading="loading"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="getUserProfile.employee.id == detail.employee.id"
            color="error"
            text
            outlined
            :loading="loading"
            @click="deleteAllFile"
          >
            Delete all File
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="uploadDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        lazy-validation
        ref="entryFormUpload"
        @submit.prevent="submitUploadDoc"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> UPLOAD </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div class="vPadX0Y10">
                <v-col cols="12" class="vPad0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Subject
                  </p>
                </v-col>
                <v-col cols="12" class="vPad0">
                  <div>
                    <v-text-field
                      outlined
                      v-model="file_subject"
                      dense
                      :rules="rules.subjectRules"
                    ></v-text-field>
                  </div>
                  <div
                    style="padding: 10px; border: 2px dashed grey; height: 70px"
                  >
                    <v-file-input
                      ref="uploadDoc"
                      placeholder="Pilih File"
                      dense
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      @change="uploadFileDoc"
                      :rules="rules.docRules"
                    ></v-file-input>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeFileUpload"
              color="error"
              text
              outlined
              type="reset"
              @click="uploadDoc('close')"
              :loading="loading"
            >
              close
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
              :disabled="fileNameRab == '' || file_subject == ''"
            >
              simpan file
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="pdfDialog" width="90%" @click:outside="closePdf">
      <v-card style="position: relative; width: 100%; height: 90vh">
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              @click.prevent="closePdf"
              v-bind="attrs"
              v-on="on"
              text
              icon
              color="white"
              style="
                position: fixed;
                top: 10px;
                right: 10px;
                z-index: 3;
                filter: drop-shadow(1px 1px 1px white);
              "
            >
              <v-icon color="black">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
        <div
          id="loader"
          class="d-flex justify-center align-center"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        >
          <v-progress-circular
            v-if="isPdfOpen && selectedPdf !== null"
            :rotate="-90"
            :size="150"
            :width="15"
            :value="value"
            color="black"
          >
            {{ value / 10 }}%
          </v-progress-circular>
        </div>
        <div v-if="showPdf" style="height: 100%; padding: 5px 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                @click.prevent="closePdf"
                v-bind="attrs"
                v-on="on"
                text
                icon
                outlined
                color="white"
                style="position: fixed; top: 10px; right: 10px; z-index: 3"
              >
                <v-icon color="black">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
          <vue-pdf-app
            v-if="selectedPdf !== null"
            @pages-rendered="pagesRendered"
            @open="openHandler"
            :pdf="selectedPdf"
            :file-name="detail.budget_no"
          >
            <template #toolbar-sidebar-prepend="{ toggleTheme }">
              <button @click="toggleTheme = null" type="button">
                Toggle theme
              </button>
            </template>
          </vue-pdf-app>

          <div
            v-else
            class="d-flex justify-center align-center"
            style="
              height: 100%;
              width: 100%;
              margin-left: auto;
              position: relative;
              z-index: 1;
              background: #eaeaea;
            "
          >
            <h3 style="margin: 0">File Not Found</h3>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectApprovalDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        ref="selectApprovalForm"
        @submit.prevent="
          detail.status.id == 0
            ? submitNow()
            : detail.status.id == 1
            ? fetchMatrix()
            : null
        "
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Ingin merubah approval default ?
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p style="margin: 0; font-weight: bold">
                    Silahkan pilih approval matrix yang dikehendaki
                  </p>
                  <v-card-subtitle
                    >*kosongkan jika tidak ingin merubah
                    approval</v-card-subtitle
                  >
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="height: 45px">
                    <v-autocomplete
                      v-model="approval_matrix_id"
                      :items="dropdownApprovalMatrix"
                      :search-input.sync="approvalSearch"
                      style="margin: 0"
                      label="Pilih Approval"
                      placeholder="kosongkan jika tidak ingin merubah approval"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      hide-details
                      hide-no-data
                      hide-selected
                      clearable
                    ></v-autocomplete>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              @click="closeApprovalDialog"
              :loading="loading"
            >
              Batal
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              type="submit"
              text
              outlined
              :loading="loading"
            >
              Lanjutkan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <div style="position: absolute; right: 15px; top: 1px" class="d-flex">
      <h6
        class="mr-2"
        style="
          text-align: right;
          border: 1px solid rgba(0, 0, 0, 0.3);
          border-radius: 5px;
          cursor: pointer;
        "
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              icon
              small
              @click="previousPage"
              v-bind="attrs"
              v-on="on"
              :disabled="
                Number($route.query.idx) === 0 || $route.query.idx === undefined
              "
            >
              <v-icon style="position: relative; top: -1px; right: 0"
                >mdi-chevron-left</v-icon
              >
            </v-btn>
          </template>
          <span>previous</span>
        </v-tooltip>
      </h6>
      <p style="margin: 0; position: relative; top: 3px">
        <span>
          {{
            $route.query.idx !== undefined ? Number($route.query.idx) + 1 : '1'
          }}
        </span>
        /
        <span v-if="$route.params.path != 'notification'">
          <span v-if="getRabList.list != null">
            {{ $route.query.idx !== undefined ? getRabList.list.length : '1' }}
          </span>
        </span>
        <span v-else>
          <span v-if="getNotificationQueue.list != null">
            {{
              $route.query.idx !== undefined
                ? getNotificationQueue.list.length
                : '1'
            }}
          </span>
        </span>
      </p>
      <h6
        class="ml-2"
        style="
          text-align: right;
          border: 1px solid rgba(0, 0, 0, 0.3);
          border-radius: 5px;
          cursor: pointer;
        "
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              v-if="$route.query.idx === undefined"
              icon
              small
              @click="nextPage"
              v-bind="attrs"
              v-on="on"
              disabled
            >
              <v-icon style="position: relative; top: -1px; right: 0"
                >mdi-chevron-right</v-icon
              >
            </v-btn>
            <div v-else>
              <div v-if="$route.params.path != 'notification'">
                <v-btn
                  v-if="getRabList.list != null"
                  icon
                  small
                  @click="nextPage"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    Number($route.query.idx) === getRabList.list.length - 1
                  "
                >
                  <v-icon style="position: relative; top: -1px; right: 0"
                    >mdi-chevron-right</v-icon
                  >
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  v-if="getNotificationQueue.list != null"
                  icon
                  small
                  @click="nextPage"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    Number($route.query.idx) ===
                    getNotificationQueue.list.length - 1
                  "
                >
                  <v-icon style="position: relative; top: -1px; right: 0"
                    >mdi-chevron-right</v-icon
                  >
                </v-btn>
              </div>
            </div>
          </template>
          <span>next</span>
        </v-tooltip>
      </h6>
    </div>
  </v-container>

  <!-- <div
      v-else
      class="d-flex justify-center align-center"
      style="width:100%; height:80vh;position:relative;"
    >
      <v-btn
        type="button"
        rounded
        elevation="0"
        color="red"
        class="white--text font-weight-bold ma-2"
        style="font-size:12px; position:absolute; top: 10px; left:10px;"
        @click.prevent="close"
        :loading="loading"
        outlined
      >
        <v-icon small>mdi-chevron-left</v-icon>
        Kembali
      </v-btn>
      <p style="color: RGBA(0,0,0,0.5); font-size:24px; font-weight:bold;">
        DATA NOT FOUND
      </p>
    </div> -->
  <!-- </div>

  <div v-else class="d-flex justify-center align-center" style="height: 100%">
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div> -->
</template>
<script>
import 'vue-pdf-app/dist/icons/main.css'
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'
import buildType from '../../../services/buildType'
export default {
  name: 'rabdetail',
  components: {},
  data() {
    return {
      hrsApi: buildType.apiURL('hrs'),
      eSanqua: buildType.apiURL('esanqua'),
      proc: buildType.apiURL('proc'),
      upload: buildType.apiURL('upload2'),
      oAuth: buildType.apiURL('oauth'),
      build: process.env.VUE_APP_BUILD_TYPE,
      wWidth: window.innerWidth,
      dialog: false,
      cancelDialog: false,
      dokumenDialog: false,
      fileNameRab: null,
      loading: false,
      detail: null,
      formHeader: null,
      formItem: null,
      rabResult: [],
      fpbResult: [],
      rabDialog: false,
      uploadDialog: false,
      isEdit: false,

      dropdown: {
        company: [],
        department: [],
        project: [],
        category: [],
        uom: [],
        vendor: [],
        currency: [],
        categoryPr: [
          { id: 'bahan_baku', name: 'Bahan Baku' },
          { id: 'bahan_pendukung', name: 'Bahan Pendukung' },
          { id: 'asset', name: 'Asset' },
          { id: 'barang_khusus', name: 'Barang Khusus' },
          { id: 'operasional', name: 'Operasional' },
          { id: 'project', name: 'Project' },
          { id: 'lain', name: 'Lain-lain' }
        ],
        categoryItem: [
          { id: 1, name: 'Raw Material' },
          { id: 2, name: 'Factory Supply' },
          { id: 3, name: 'Office Supply' },
          { id: 4, name: 'Sparepart' },
          { id: 5, name: 'Jasa' },
          { id: 6, name: 'Maintenance Repair' },
          { id: 7, name: 'Investment / Asset' },
          { id: 23, name: 'Event' }
        ]
      },
      rules: {
        company: [],
        qtyRules: [],
        prRules: [],
        itemRules: [],
        nameRules: [],
        categoryRules: [],
        uomRules: [],
        budgetRules: [],
        estimateDateRules: [],
        vendorRules: []
      },
      selectedData: [],
      selectedItem: null,
      itemEdit: null,
      catalogueItems: [],
      searchCatalogue: null,
      selectCatalogue: null,
      searchVendor: null,
      selectVendor: null,
      searchItem: '',
      searchFpb: '',
      createFpbDialog: false,
      formFpb: {
        category_item: null,
        category_pr: null
      },
      comment: null,
      commentDialog: false,
      file_subject: '',

      value: 0,
      counter: 0,
      timer: 100,
      isPdfOpen: false,
      selectedPdf: null,
      showPdf: false,
      info: [],
      pdfDialog: false,
      approval_matrix_id: null,
      dropdownApprovalMatrix: [],
      approvalSearch: null,
      approvalSelect: null,
      selectApprovalDialog: false,
      isAllow: false,
      digitAfterComa: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  watch: {
    searchCatalogue() {
      if (this.searchCatalogue == null || this.searchCatalogue == '') {
        this.catalogueItems = []
      }
    },
    selectedItem(val) {
      console.log('selectedItem >>>', val)
      if (val != null) {
        if (val.product != null && val.product.uom_id != null) {
          this.formItem.uom = {
            id: val.product.uom_id,
            name: val.product.uom_name
          }
          this.formItem.vendor_recomendation =
            val.vendor != null ? val.vendor : null
          if (val.vendor != null) {
            this.formItem.vendor = val.vendor
            this.vendorSelections(val.vendor.name)
          }
        }
      }
    },
    approvalSearch(val) {
      if (val !== null) {
        if (val !== '') {
          val &&
            val !== this.approvalSelect &&
            this.getApprovalMatrixDropdown(val)
        } else {
          this.approvalSelect = null
          this.dropdownApprovalMatrix = []
        }
      } else {
        this.approvalSelect = null
        this.dropdownApprovalMatrix = []
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getRabList', 'getNotificationQueue']),
    headers() {
      const arrHeaders = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kode Barang',
          value: 'product.code',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama Barang',
          value: 'product.name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kategori',
          value: 'category',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty',
          value: 'qty',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty FPB',
          value: 'fpb_qty',
          align: 'left',
          sortable: false
        },
        {
          text: 'Sisa',
          value: 'qty_remain',
          align: 'left',
          sortable: false
        },
        {
          text: 'Satuan',
          value: 'uom.name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Budget Satuan',
          value: 'budget_price_per_unit',
          align: 'left',
          sortable: false
        },
        {
          text: 'Budget Total',
          value: 'budget_price_total',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Pakai',
          value: 'estimate_date_use',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ref. Vendor',
          value: 'vendor_recomendation',
          align: 'left',
          sortable: false
        },
        {
          text: 'RAB Origin',
          value: 'rab_origin',
          align: 'left',
          sortable: false
        }
      ]
      if (this.detail != null) {
        if (this.detail.rab_type == 2) {
          arrHeaders.push({
            text: 'FPB',
            value: 'fpb_ids',
            align: 'left',
            sortable: false
          })
        }
        if (this.detail.status.id == 0) {
          arrHeaders.push({
            text: 'Action',
            value: 'action',
            align: 'left',
            sortable: false
          })
        }
        // if (this.detail.status.id != 0) {
        //   arrHeaders.pop()
        // }
      }
      return arrHeaders
    },
    approvalHeaders() {
      const arrHeaders = [
        { text: 'Sequence', value: 'sequence', align: 'left', width: '5%' },
        { text: 'Doc. No', value: 'document_no', align: 'left', width: '10%' },
        { text: 'Model', value: 'table_name', align: 'center', width: '10%' },
        { text: 'User', value: 'approver_user', align: 'center', width: '20%' },
        {
          text: 'Min. Approver',
          value: 'min_approver',
          align: 'center',
          width: '5%'
        },
        {
          text: 'Approved by',
          value: 'approved',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Rejected by',
          value: 'rejected',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Created at',
          value: 'created_at',
          align: 'center',
          width: '15%'
        },
        {
          text: 'Update at',
          value: 'updated_at',
          align: 'center',
          width: '15%'
        }
      ]
      return arrHeaders
    },
    fpbHeaders() {
      const arrHeaders = [
        {
          text: 'No. Request',
          value: 'request_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Company',
          value: 'company.name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Category',
          value: 'category_item.name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Project',
          value: 'project.name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jumlah budget',
          value: 'total_price',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. buat',
          value: 'created_at',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. submit',
          value: 'requested_at',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status.name',
          align: 'left',
          sortable: false
        }
      ]
      return arrHeaders
    },
    selectedItemHeader() {
      const arrHeaders = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kode Barang',
          value: 'product.code',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama Barang',
          value: 'product.name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty Sisa',
          value: 'qty_remain',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty FPB',
          value: 'qty_fpb',
          align: 'left',
          sortable: false
        },
        {
          text: 'Satuan',
          value: 'uom.name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Budget Satuan',
          value: 'budget_price_per_unit',
          align: 'left',
          sortable: false
        },
        {
          text: 'Budget Total',
          value: 'budget_price_total',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Pakai',
          value: 'estimate_date_use',
          align: 'left',
          sortable: false
        }
      ]
      return arrHeaders
    },
    dokumenHeaders() {
      const arrHeaders = [
        {
          text: 'File Name',
          value: 'subject',
          align: 'left',
          sortable: false,
          width: '90%'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false,
          width: '10%'
        }
      ]
      return arrHeaders
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    await this.getDetail()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapMutations(['openNotification', 'changeToRead']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    prCategoryWatcher(v) {
      if (v !== null) {
        if (v === 'project' || v === 'asset') {
          if (
            v == 'project' &&
            (this.detail.company.id == 5 || this.detail.company.id == 14)
          ) {
          } else {
            this.formFpb.category_item = 7
          }
        } else {
          if (this.formFpb.category_item == 7) {
            this.formFpb.category_item = null
          }
        }
      } else {
        this.formFpb.category_item = null
      }
    },
    itemCategoryWatcher(v) {
      // if (v !== null) {
      //   if (v == 7) {
      //     this.formFpb.category_pr = 'asset'
      //   } else {
      //     if (this.detail.company.id != 5 && this.detail.company.id != 14) {
      //       this.formFpb.category_pr = null
      //     } else {
      //       if (this.forformFpbm.category_pr != 'project') {
      //         this.formFpb.category_pr = null
      //       }
      //     }
      //   }
      // } else {
      //   this.form.category_pr = null
      // }
    },
    disablePrCategory(item) {
      if (this.detail.project == null) {
        return item.id == 'project'
      } else {
        return false
      }
    },
    disableCategoryItem(item) {
      if (
        this.formFpb.category_pr != 'project' &&
        this.formFpb.category_pr != 'asset'
      ) {
        return item.id == 7
      } else {
        return item.id != 7 && item.id != 23
      }
    },
    customSearch(value, search, item) {
      return Object.values(item.product).some(
        (v) => v && v.toString().toLowerCase().includes(search)
      )
    },
    enterSearch(val) {
      val && val != this.selectCatalogue && this.querySelections(val)
    },
    querySelections(v) {
      const getCatalogue = () => {
        return new Promise((resolve) => {
          axios
            .get(
              // `${this.proc}vendor/catalogue/list?keyword=${v}&offset=0&limit=10&vendor_id=&category_id=`
              `${this.proc}vendor/catalogue/dropdown_product?keyword=${v}`
            )
            .then((res) => {
              console.log('catalogue>>>', res)
              resolve(res.data.data)
            })
        })
      }

      // this.loading = true
      getCatalogue().then((res) => {
        if (res != undefined) {
          this.catalogueItems = res
        } else {
          this.catalogueItems = []
        }
        // this.loading = false
      })
    },
    vendorSearch(val) {
      val && val != this.selectVendor && this.vendorSelections(val)
    },
    vendorSelections(v) {
      const getVendor = () => {
        return new Promise((resolve) => {
          axios
            .get(
              // `${this.proc}vendor/catalogue/list?keyword=${v}&offset=0&limit=10&vendor_id=&category_id=`
              `${this.proc}vendor/dropdown?keyword=${v}&offset=0&limit=100&order_by=code&order_type=desc`
            )
            .then((res) => {
              console.log('vendor dropdown>>>', res)
              resolve(res.data.data)
            })
        })
      }

      // this.loading = true
      getVendor().then((res) => {
        if (res != undefined) {
          this.dropdown.vendor = res
        } else {
          this.dropdown.vendor = []
        }
        // this.loading = false
      })
    },
    rowClick(pValue) {
      this.itemEdit = pValue
      console.log('item>>>>', pValue)
      this.initDropdown()
      setTimeout(() => {
        this.openRabItemDialog('update')
        if (
          pValue.vendor_recomendation != null &&
          pValue.vendor_recomendation.name != null
        ) {
          this.vendorSearch(pValue.vendor_recomendation.name)
        }
        // document.getElementById('fpbFormEdit').click()
      }, 500)
    },
    async getDetail() {
      this.loading = true
      this.detail = null
      const url = `${this.proc}rab/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('detail>>>', res)
          if (res.data.status_code != '-99') {
            // res.data.data.
            this.detail = res.data.data
            this.authorityCheck(res.data.data)
            this.getListFpb()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          return (this.loading = false)
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.loading = false)
        })
    },
    async getListFpb() {
      this.fpbResult = []
      const url = `${this.proc}fpb/list?keyword=&offset=0&limit=10&company_id=${this.detail.company.id}&budget_plan_id=${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.fpbResult = res.data.data
            console.log('fpbResult>>>', res)
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog('error', err.msg, false)
        })
    },
    openDetailFpb(pValue, pSlot) {
      // this.$store.commit('setFpbId', pValue.id)
      const arrItem = {
        list: this.fpbResult
        // index: pSlot.index
      }
      this.$store.commit('setFpbList', arrItem)
      setTimeout(() => {
        window.open(
          `/e-catalogue/fpb-list/fpb/${pValue.id}?idx=${pSlot.index}`,
          '_blank'
        )
        // this.$router.push(
        //   `/e-catalogue/fpb-list/fpb/${pValue.id}?idx=${pSlot.index}`
        // )
        // this.$router.push('/e-catalogue/fpb-list/fpb')
      }, 200)
    },
    authorityCheck(item) {
      if (item.approval_matrix !== null) {
        const matrixId = item.approval_matrix[0].document_id
        axios
          .get(
            `${this.oAuth}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=2&table_name=tr_budgetplans`
          )
          .then((res) => {
            if (res.data.status_code !== '-99') {
              if (res.data.is_allow_approve !== 0) {
                this.isAllow = true
              } else {
                this.isAllow = false
              }
            } else {
              this.isAllow = false
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Cek Otoritas error, Silahkan info ke Admin'
                : 'Cek Otoritas error, Silahkan info ke Admin',
              false
            )
          })
      }
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    close() {
      if (this.detail != null) {
        this.$refs.entryForm.reset()
      }
      if (this.prevRoute != undefined) {
        if (this.prevRoute.path != '/e-catalogue/rab/submission') {
          this.$router.push(this.prevRoute.path)
        } else {
          this.$router.push('/e-catalogue/rab')
        }
      } else {
        this.$router.push('/e-catalogue/rab')
      }
    },
    editHeader() {
      this.formHeader = {
        name: this.detail.name,
        project: this.detail.project,
        company: this.detail.company,
        pic_employee: this.detail.pic_employee
      }
      this.dropdownProject()
      this.isEdit = true
      // this.setRabDetail(this.detail)
      // setTimeout(() => {
      //   this.$router.push('/e-catalogue/rab/submission')
      // }, 300)
    },
    cancelHeader() {
      this.dropdown.project = []
      this.detail.project = this.formHeader.project
      setTimeout(() => {
        this.isEdit = false
      }, 100)
    },

    submitHeader() {
      if (this.detail.budget_category == null) {
        return this.showMsgDialog(
          'warning',
          'Kolom kategori wajib diisi',
          false
        )
      }
      if (this.detail.budget_category == 'project') {
        if (this.detail.project == null || this.detail.project.id == null) {
          return this.showMsgDialog(
            'warning',
            'Kolom project wajib diisi',
            false
          )
        }
      } else {
        this.detail.project = null
      }

      const self = this
      // this.rules.nameRules = [v => !!v || 'Nama project diperlukan']
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      const project = this.detail.project != null
      const form = {
        act: 'update',
        name: this.detail.name,
        project_id: project ? this.detail.project.id : null,
        project_name: project ? this.detail.project.name : null,
        project_code: project ? this.detail.project.code : null,
        note: this.detail.note,
        budget_category: this.detail.budget_category
        // company_id: this.detail.company.id,
        // company_name: this.detail.company.name,
        // pic_employee_id: this.detail.pic_employee.id,
        // pic_employee_nik: this.detail.pic_employee.nik,
        // pic_employee_name: this.detail.pic_employee.name
      }
      if (form.act == 'update') {
        Object.assign(form, {
          id: this.detail.id
        })
      }
      console.log(form)
      this.save(form)
    },
    async save(form) {
      this.loading = true
      await axios
        .post(`${this.proc}rab/save`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code != '-99') {
            this.formHeader = null
            this.dropdown.project = []
            this.isEdit = false
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDetail()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          return null
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
          return null
        })
    },
    submitRAB() {
      console.log(this.detail.budget_plan_detail)
      if (this.detail.budget_category == null) {
        return this.showMsgDialog(
          'warning',
          'Kolom kategori wajib diisi sebelum submit',
          false
        )
      }

      if (
        this.detail.budget_category == 'project' &&
        (this.detail.project == null || this.detail.project.id == null)
      ) {
        return this.showMsgDialog(
          'warning',
          'Kolom project wajib diisi sebelum submit',
          false
        )
      }

      const hasFreeText = this.detail.budget_plan_detail.find(
        ({ product }) => product.code == null
      )

      if (
        this.detail.budget_category != 'project' &&
        hasFreeText != undefined
      ) {
        return this.showMsgDialog(
          'warning',
          'Tidak dapat memproses barang FREE TEXT untuk kategori RAB yang dipilih ',
          false
        )
      }
      const duplicatedItems = this.detail.budget_plan_detail.filter(
        (item, index, self) =>
          index !==
          self.findIndex(
            (t) =>
              t.product.name === item.product.name &&
              t.budget_price_per_unit === item.budget_price_per_unit &&
              t.uom.name === item.uom.name
          )
      )
      console.log(duplicatedItems)
      if (duplicatedItems.length > 0) {
        return this.showMsgDialog(
          'warning',
          `Tidak dapat submit RAB, Terdeteksi duplikasi nama barang, unit dan budget yang sama persis ("${duplicatedItems[0].product.name}"), silahkan gabungkan atau rubah nama / budgetnya dahulu`,
          false
        )
      }
      this.showMsgDialog3(
        'warning',
        'Pastikan semua data sudah terisi dengan benar',
        true,
        'Submit Sekarang',
        'Batalkan'
      ).then(async (res) => {
        if (res.isConfirmed) {
          // const xFlag = false
          const xCheckDateUse = this.detail.budget_plan_detail.find(
            ({ estimate_date_use }) =>
              estimate_date_use == null ||
              estimate_date_use == '' ||
              isNaN(new Date(estimate_date_use).getTime())
          )
          if (xCheckDateUse != undefined) {
            return this.showMsgDialog(
              'warning',
              `Terdeteksi ada item yang estimasi tanggal dipakai tidak terisi atau invalid (${xCheckDateUse.product.name})`,
              false
            )
          }

          // const xFlag = true
          // if (xFlag) {
          if (
            (this.detail.status.id == 0 || this.detail.status.id == 1) &&
            this.getUserProfile != null &&
            this.getUserProfile.employee != null &&
            this.getUserProfile.employee.department != null &&
            (this.getUserProfile.employee.department.id == 3 ||
              this.getUserProfile.employee.department.id == 9 ||
              this.getUserProfile.employee.department.id == 59)
          ) {
            this.getApprovalMatrixDropdown('')
            setTimeout(() => {
              this.selectApprovalDialog = true
            }, 300)
          } else {
            this.submitNow()
          }
        }
      })
    },
    submitNow() {
      this.loading = true
      const form = {
        id: this.$route.params.id,
        approval_matrix_id: this.approval_matrix_id
      }
      axios
        .post(`${this.proc}rab/submit`, form)
        .then(async (res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            if (this.detail.approval_matrix !== null) {
              await this.fetchMatrix()
              // console.log('fetch done')
            } else {
              this.getDetail()
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
          }
          this.selectApprovalDialog = false
        })
        .catch((err) => {
          console.log(err)
          this.selectApprovalDialog = false
          this.loading = false
        })
    },
    confirmRAB() {
      this.showMsgDialog2(
        'question',
        'Setujui RAB ini sekarang ?',
        true
        // inputType,
        // inputAtt
      ).then((res) => {
        if (res.isConfirmed) {
          const document_id = this.$route.params.id
          this.loading = true
          axios
            .post(`${this.proc}rab/confirm`, {
              document_id: document_id,
              note: res.value
            })
            .then((res) => {
              this.showMsgDialog('success', res.data.status_msg, false)
              this.loading = false
              this.getDetail()
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    rejectRAB() {
      this.showMsgDialog2('question', 'Jangan setujui RAB ini ?', true).then(
        (res) => {
          if (res.isConfirmed) {
            this.loading = true

            const date = new Date()
            const local = date.toLocaleString('id')
            const updateAt = `[${local}]\n${res.value}`
            axios
              .post(`${this.proc}rab/reject`, {
                document_id: this.$route.params.id,
                reject_reason: updateAt
              })
              .then((res) => {
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                } else {
                  this.showMsgDialog('error', res.data.status_msg, false)
                }
                this.loading = false
                this.getDetail()
              })
              .catch((err) => {
                console.log(err)
                this.loading = false
              })
          }
        }
      )
    },
    takeRAB() {
      this.showMsgDialog('question', 'Proses RAB ini ?', true).then((res) => {
        if (res.isConfirmed) {
          this.loading = true
          axios
            .post(`${this.proc}rab/take`, {
              id: this.$route.params.id
            })
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', 'take success', false)
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              this.getDetail()
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    setToDraftRAB() {
      this.showMsgDialog('question', 'Kembalikan ke draft ?', true).then(
        (res) => {
          if (res.isConfirmed) {
            this.loading = true
            axios
              .post(`${this.proc}rab/set_to_draft`, {
                id: this.$route.params.id
              })
              .then((res) => {
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', 'set to draft success', false)
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
                this.loading = false
                this.getDetail()
              })
              .catch((err) => {
                console.log(err)
                this.loading = false
              })
          }
        }
      )
    },
    doneRAB() {
      this.showMsgDialog(
        'question',
        'Sudah selesai ?',
        true
        // inputType,
        // inputAtt
      ).then((res) => {
        if (res.isConfirmed) {
          const id = this.$route.params.id
          this.loading = true
          axios
            .post(`${this.proc}rab/done`, {
              id: id
            })
            .then((res) => {
              this.showMsgDialog('success', res.data.status_msg, false)
              this.loading = false
              this.getDetail()
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    cancelRAB() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin membatalkan RAB ini ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          this.loading = true

          // const date = new Date()
          // const local = date.toLocaleString('id')
          const updateAt = res.value
          axios
            .post(`${this.proc}rab/cancel`, {
              id: this.$route.params.id,
              cancel_reason: updateAt
            })
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                this.showMsgDialog('error', res.data.status_msg, false)
              }
              this.loading = false
              this.getDetail()
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    dropdownProject() {
      this.dropdown.project = []
      let url = `${this.proc}globalmaster/project/dropdown?keyword=`

      const filter = []
      // &status=${this.paramAPI.status}
      if (this.detail.company != null) {
        filter.push(`{"company_id":${this.detail.company.id}}`)
      }
      url = url + `&filter=[${filter}]`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdown.project = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dropdownUnit() {
      this.dropdown.uom = []
      const url = `${this.proc}master/unit/drop_down?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdown.uom = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dropdownCategory() {
      this.dropdown.category = []
      const url = `${this.proc}master/product_category/drop_down?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdown.category = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dropdownCurrency() {
      this.dropdown.currency = []
      const url = `${this.proc}master/currency/drop_down?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code == '00') {
            if (res.data.data.length > 0) {
              for (let i = 0; i < res.data.data.length; i++) {
                this.dropdown.currency.push({
                  id: Number(res.data.data[i].id),
                  code: res.data.data[i].code,
                  symbol: res.data.data[i].symbol
                })
              }
            }

            console.log('dropdown currency>>>', this.dropdown.currency)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    submitItem() {
      const self = this
      this.rules.nameRules = [(v) => !!v || 'Nama project diperlukan']
      // this.rules.codeRules = [v => !!v || 'Kode project diperlukan']
      this.rules.qtyRules = [(v) => !!v || 'Qty diperlukan']
      this.rules.uomRules = [(v) => !!v || 'Uom diperlukan']
      this.rules.budgetRules = [(v) => !!v || 'Budget diperlukan']
      // this.rules.estimateDateRules = [v => !!v || 'Tgl Pemakaian diperlukan']
      this.rules.vendorRules = [(v) => !!v || 'Vendor diperlukan']

      setTimeout(function () {
        if (self.$refs.entryFormItem.validate()) {
          self.createNewItemForm()
        }
      })
    },
    createNewItemForm() {
      let product = null
      let vendor = null
      let currency = null
      let vendor_recomendation = null

      if (this.formItem.search_from_ecatalogue) {
        if (this.formItem.act == 'add') {
          if (this.selectedItem != null) {
            product = this.selectedItem.product
            vendor = this.selectedItem.vendor
            vendor_recomendation = this.formItem.vendor_recomendation
            currency = this.selectedItem.currency
          }
        } else {
          product = this.formItem.product
          vendor = this.formItem.vendor
          currency = this.formItem.currency
          vendor_recomendation = this.formItem.vendor_recomendation
        }
      } else {
        if (this.formItem.product != null) {
          product = this.formItem.product
        }
        vendor = this.formItem.vendor
        currency = this.formItem.currency
        vendor_recomendation = this.formItem.vendor_recomendation
      }
      console.log('vendor>>>>', vendor)
      console.log('vendor_recomendation>>>>', vendor_recomendation)

      const form = {
        act: this.formItem.act,

        request_id: this.$route.params.id,
        product_id: product != null ? product.id : null,
        product_name:
          product != null ? product.name : this.formItem.product_name,
        product_code: product != null ? product.code : null,
        category_id:
          this.formItem.category != null ? this.formItem.category.id : null,
        category_name:
          this.formItem.category != null ? this.formItem.category.name : null,
        qty: this.formItem.qty,
        uom_id: this.formItem.uom != null ? this.formItem.uom.id : null,
        uom_name: this.formItem.uom != null ? this.formItem.uom.name : null,
        description: this.formItem.description,
        type: this.formItem.type,
        merk: this.formItem.merk,
        dimension: this.formItem.dimension,
        material: this.formItem.material,
        photo: this.formItem.photo,
        budget_price_per_unit: this.formItem.budget_price_per_unit,
        estimate_date_use: this.formItem.estimate_date_use,
        vendor_id: vendor != null ? vendor.id : null,
        vendor_name: vendor != null ? vendor.name : null,
        vendor_code: vendor != null ? vendor.code : null,
        // vendor_recomendation: this.formItem.vendor_recomendation,
        vendor_recomendation:
          vendor_recomendation != null ? vendor_recomendation.name : null,
        vendor_recomendation_id:
          vendor_recomendation != null ? vendor_recomendation.id : null,
        vendor_recomendation_code:
          vendor_recomendation != null ? vendor_recomendation.code : null,
        section_title: this.formItem.section_title,
        rab_origin_id: this.$route.params.id,
        currency_id: currency != null ? currency.id : null,
        currency_code: currency != null ? currency.code : null,
        currency_symbol: currency != null ? currency.symbol : null
      }
      if (form.act == 'update') {
        Object.assign(form, {
          id: this.itemEdit.id
        })
      }
      console.log('Save item>>>>', form)
      const checkDouble = this.detail.budget_plan_detail.find(
        ({ product, budget_price_per_unit, uom }) =>
          product.name.toLowerCase() == form.product_name.toLowerCase() &&
          product.code == form.product_code &&
          form.uom_id == uom.id &&
          form.budget_price_per_unit == budget_price_per_unit
      )
      if (form.act == 'add') {
        if (checkDouble != undefined) {
          this.showMsgDialog(
            'warning',
            `"${form.product_name}" sudah digunakan dengan unit dan budget yang sama persis, harap gunakan nama lain atau ubah unit dan nominalnya`,
            false
          )
        } else {
          this.saveDetailItem(form)
        }
      } else {
        this.saveDetailItem(form)
      }
    },
    async saveDetailItem(form) {
      this.loading = true
      await axios
        .post(`${this.proc}rab/save_detail`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.closeRabItemDialog()
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDetail()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          return null
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
          return null
        })
    },
    async deleteItem(v) {
      console.log('Delete>>>>', v)
      this.loading = true
      await axios
        .delete(`${this.proc}rab/delete_detail/${v.id}`)
        .then((res) => {
          this.loading = false
          if (res.data.status_code != '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDetail()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          return null
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
          return null
        })
    },
    initDropdown() {
      this.dropdownUnit()
      this.dropdownCategory()
      this.dropdownCurrency()
      if (this.itemEdit != null && this.itemEdit.vendor != null) {
        this.vendorSelections(this.itemEdit.vendor.name)
      }
    },
    openRabItemDialog(act) {
      this.setFormItem(act)
      if (act == 'add') {
        this.initDropdown()
      }
      setTimeout(() => {
        this.rabDialog = true
      }, 300)
    },
    closeRabItemDialog() {
      this.rabDialog = false
      setTimeout(() => {
        this.itemEdit = null
        this.formItem = null
        this.dropdown.uom = []
        this.dropdown.category = []
        this.dropdown.vendor = []
        this.dropdown.currency = []
      }, 300)
    },
    setFormItem(act) {
      const form = {
        act: act,
        search_from_ecatalogue: false,
        product: null,
        product_name: '',
        category: null,
        qty: 0,
        uom: null,
        description: '',
        type: '',
        merk: '',
        dimension: '',
        material: '',
        photo: '',
        budget_price_per_unit: 0,
        estimate_date_use: new Date().toISOString().split('T')[0],
        vendor: null,
        vendor_recomendation: null,
        section_title: null,
        currency: null
      }
      if (this.detail.budget_category != 'project') {
        form.search_from_ecatalogue = true
      }
      if (form.act == 'update') {
        if (this.itemEdit.product.id != null) {
          this.querySelections(this.itemEdit.product.name)
          form.search_from_ecatalogue = true
        }
        form.product = this.itemEdit.product
        form.product_name = this.itemEdit.product.name
        // form.product.code = this.itemEdit.product.code
        // form.product.name = this.itemEdit.product.name
        form.vendor = this.itemEdit.vendor
        // form.vendor.code = this.itemEdit.vendor.code
        // form.vendor.name = this.itemEdit.vendor.name
        form.vendor_recomendation = this.itemEdit.vendor_recomendation
        form.category = this.itemEdit.category
        if (this.itemEdit.category != null) {
          form.category.id = Number(this.itemEdit.category.id)
        }
        // form.category.name = this.itemEdit.category.name
        form.qty = this.itemEdit.qty
        form.uom = this.itemEdit.uom
        // form.uom.name = this.itemEdit.uom.name
        form.budget_price_per_unit = this.itemEdit.budget_price_per_unit
        form.description = this.itemEdit.description
        form.type = this.itemEdit.type
        form.material = this.itemEdit.material
        form.merk = this.itemEdit.merk
        form.dimension = this.itemEdit.dimension
        form.photo = this.itemEdit.photo
        form.estimate_date_use = this.convertDate(
          this.itemEdit.estimate_date_use
        )
        form.section_title = this.itemEdit.section_title
        form.currency = this.itemEdit.currency
      }

      this.formItem = form
    },

    createFPB() {
      console.log('Create >>>>', this.selectedData)
      for (let i = 0; i < this.selectedData.length; i++) {
        this.selectedData[i].qty_fpb =
          this.selectedData[i].qty_remain > 0
            ? this.selectedData[i].qty_remain
            : 0
      }
      if (this.detail.budget_category != null) {
        this.formFpb.category_pr = this.detail.budget_category
        this.formFpb.category_item =
          this.detail.budget_category == 'project' ? 7 : null
      } else {
        this.formFpb.category_pr = 'project'
        this.formFpb.category_item = 7
      }
      setTimeout(() => {
        this.createFpbDialog = true
      }, 300)
    },
    closeFpbDialog() {
      this.selectedData = []
      setTimeout(() => {
        this.getDetail()
        this.createFpbDialog = false
      }, 300)
    },

    checkBeforeSubmitFpb() {
      let xFlag = false
      if (
        this.formFpb.category_pr == 'asset' ||
        this.formFpb.category_pr == 'project'
      ) {
        if (this.formFpb.category_pr == 'asset') {
          const notAssetCode = this.selectedData.find(
            ({ product }) => !product.code.includes('AST')
          )
          if (notAssetCode !== undefined) {
            this.showMsgDialog(
              'warning',
              "Kategori PR yang dipilih hanya untuk barang dengan kode 'AST'",
              false
            )
          } else {
            xFlag = true
          }
        } else {
          xFlag = true
        }
      } else {
        const isAssetCode = this.selectedData.find(
          ({ product }) => product.code == null || product.code.includes('AST')
        )
        if (isAssetCode !== undefined) {
          this.showMsgDialog(
            'warning',
            "Tidak dapat memproses barang dengan kode 'AST' ataupun FREE TEXT untuk kategori PR yang dipilih",
            false
          )
        } else {
          xFlag = true
        }
      }

      if (xFlag) {
        if (this.selectedData == null || this.selectedData.length == 0) {
          this.showMsgDialog('warning', 'Belum ada item yang dipilih', false)
        } else {
          this.submitFPB()
        }
      }
    },
    submitFPB() {
      const self = this
      this.rules.qtyRules = [
        (v) => !!v || 'Harus diisi',
        (v) => v > 0 || 'Tidak boleh 0'
      ]
      this.rules.itemRules = [(v) => !!v || 'Harus diisi']
      this.rules.prRules = [(v) => !!v || 'Harus diisi']
      setTimeout(function () {
        if (self.$refs.entryFormFpb.validate()) {
          // self.createNewForm()
          console.log('this.selectedData >>>>', self.selectedData, self.detail)
          const form = {
            act: 'add_batch_in_item',
            reference_from_ecommerce: 0,
            budget_is_approved: 0,
            memo_special_request: 0,
            purchase_request_detail: [],
            category_item: self.formFpb.category_item,
            project_id:
              self.detail.project != null ? self.detail.project.id : null,
            budget_plan_id: self.$route.params.id,
            category_pr: self.formFpb.category_pr,
            company_id: self.detail.company.id,
            company_name: self.detail.company.name,
            company_code: self.alias(self.detail.company.id)
          }
          // check if there qty_fpb exceed qty_remain ?
          // const qtyCheck = self.selectedData.find(
          //   ({ qty_fpb, qty_remain }) => qty_fpb > qty_remain
          // )
          // if (qtyCheck != undefined) {
          //   self.showMsgDialog(
          //     'warning',
          //     `Invalid qty, qty fpb tidak boleh melebihi qty sisa.\n[${qtyCheck.product.name}]`,
          //     false
          //   )
          // } else {
          for (let i = 0; i < self.selectedData.length; i++) {
            let currency = null
            if (self.selectedData[i].currency != null) {
              currency = self.selectedData[i].currency
            }
            const obj = {
              product_id: self.selectedData[i].product.id,
              product_name: self.selectedData[i].product.name,
              product_code: self.selectedData[i].product.code,
              qty: Number(self.selectedData[i].qty_fpb),
              budget_price_per_unit: self.selectedData[i].budget_price_per_unit,
              vendor_id: self.selectedData[i].vendor.id,
              vendor_name: self.selectedData[i].vendor.name,
              vendor_code: self.selectedData[i].vendor.code,
              has_budget: 1,
              estimate_date_use: self.convertDate(
                self.selectedData[i].estimate_date_use
              ),
              description:
                self.selectedData[i].description == ''
                  ? self.selectedData[i].product.name
                  : self.selectedData[i].description,
              uom_id: self.selectedData[i].uom.id,
              uom_name: self.selectedData[i].uom.name,
              rab_item_id: self.selectedData[i].id,
              rab_qty: self.selectedData[i].qty,
              rab_qty_remain: self.selectedData[i].qty_remain,
              currency_id: currency.id,
              currency_symbol: currency.symbol,
              currency_code: currency.code,
              vendor_rec_id: self.selectedData[i].vendor_recomendation.id,
              vendor_rec_name: self.selectedData[i].vendor_recomendation.name,
              vendor_rec_code: self.selectedData[i].vendor_recomendation.code
            }
            form.purchase_request_detail.push(obj)
          }
          // console.log(form)
          self.saveFPB(form)
          // }
        }
      })
    },
    saveFPB(form) {
      this.showMsgDialog(
        'question',
        'Anda yakin akan membuat FPB dari item tersebut ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          axios
            .post(`${this.proc}fpb/save`, form)
            .then((res) => {
              if (res.data.status_code == '00') {
                const created_id = res.data.created_id

                this.$store.commit('setFpbId', created_id)

                this.$router.push('/e-catalogue/cart/fpb')
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }

              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              console.log(err)
            })
        }
      })
    },
    getQtyWithBudgetFilled() {
      let itemQty = 0
      if (this.detail != null) {
        if (this.detail.budget_plan_detail.length > 0) {
          for (let i = 0; i < this.detail.budget_plan_detail.length; i++) {
            if (
              this.detail.budget_plan_detail[i].budget_price_per_unit != null &&
              this.detail.budget_plan_detail[i].budget_price_per_unit != 0
            ) {
              itemQty += 1
            }
          }
        }
      }
      return itemQty
    },
    price(pItem) {
      if (pItem != undefined) {
        if (pItem != null) {
          return pItem.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',')
        }
      }
      return ''
    },
    statusColor(val) {
      switch (val) {
        case 0:
          return 'color: #black; background-color: #4e4e4e1f;'
        case 1:
          return 'color: rgb(138, 90, 0); background-color: rgba(255, 166, 0, 0.3);'
        case 2:
          return 'color: #black; background-color: #4e4e4e1f;'
        case 3:
          return 'color: #1976d2; background-color: #4e4e4e1f;'
        case 4:
          return 'color: green; background-color: #4e4e4e1f;'
        case 5:
          return 'color: red; background-color: #4e4e4e1f;'
        case 6:
          return 'color: red; background-color: #4e4e4e1f;'
        default:
          return 'black'
      }
    },
    convertDate(raw) {
      let res = null
      if (raw == null || raw == undefined || raw == '') {
        res = new Date().toLocaleDateString()
      } else {
        const date = new Date(raw)
        const local = date.toLocaleDateString('id')
        const split = local.split('/')
        const day = split[0].length == 1 ? '0' + split[0] : split[0]
        const month = split[1].length == 1 ? '0' + split[1] : split[1]
        const year = split[2]
        res = `${year}-${month}-${day}`
      }
      return res
    },
    customFilter(item, queryText, itemText) {
      if (item.vendor.name == null || item.vendor.code == null) {
        return (
          item.product.name
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1 ||
          item.product.code
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1
        )
      }
      return (
        item.product.name
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.product.code
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.vendor.name
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.vendor.code
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      )
    },
    percentConvert(detail) {
      const realization = 0
      const totalPrice = detail.total_price
      let percent = 0
      if (realization != 0 && totalPrice != 0) {
        percent = (realization / totalPrice) * 100
      }
      return percent
    },
    priceConvert(xVal) {
      const num = 0
      let digitVal = 3
      if (this.digitAfterComa != null && this.digitAfterComa > 0) {
        digitVal = this.digitAfterComa
      }
      if (xVal != undefined) {
        if (xVal != null) {
          let round = xVal
          if (round.toString().includes('.')) {
            round = round.toFixed(digitVal)
          }
          const val = round + ''
          let result = ''

          if (val.includes('.')) {
            const splitVal = val.split('.')
            const main = splitVal[0]
            const decimal = splitVal[1]
            result =
              main.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',') +
              `.${decimal}`
          } else {
            result = val
              .toString()
              .replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',')
          }
          return result
        }
      }
      return num
    },
    showMsgDialog2(pModalType, pStatusMsg, pBtnCancel, pText) {
      let additional = ''
      if (pText != undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: 'textarea',
            inputLabel: 'Anda dapat memberikan catatan pada kolom dibawah ini',
            inputPlaceholder: 'Tulis sesuatu disini...',
            inputAttributes: {
              'aria-label': 'Tulis sesuatu disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    showMsgDialog3(pModalType, pStatusMsg, pBtnCancel, yesBtn, noBtn, pText) {
      let additional = ''
      if (pText != undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: yesBtn,
            cancelButtonText: noBtn != '' ? noBtn : 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    alias(id) {
      switch (id) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'BWN'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'BWI'
        case 16:
          return 'DAM'
        case 17:
          return 'PSR'
        case 18:
          return 'GAP'
        case 19:
          return 'SKH'
        case 20:
          return 'PTI'
        case 21:
          return 'BMS'
        case 22:
          return 'SDA'
      }
    },
    openCommentDialog(obj) {
      console.log(obj)
      this.comment = obj
      setTimeout(() => {
        this.commentDialog = true
      }, 100)
    },
    closeCommentDialog() {
      this.commentDialog = false
      setTimeout(() => {
        this.comment = null
      }, 100)
    },
    generatePdfRAB() {
      setTimeout(() => {
        axios({
          url: `${this.proc}rab_v2/export_to_pdf/${this.$route.params.id}`,
          method: 'GET',
          responseType: 'arraybuffer'
        })
          .then((res) => {
            this.selectedPdf = res.data
            setTimeout(() => {
              this.viewPDF()
            }, 1000)
          })
          .catch((error) => {
            console.log(error)
          })
      }, 2000)
    },
    downloadDokumen() {
      // if (this.detail.file != null) {
      // if (this.detail.file.length > 0) {
      setTimeout(() => {
        this.dokumenDialog = true
      }, 300)
      // } else {
      //   this.showMsgDialog('warning', 'Belum ada file yang diupload', false)
      // }
      // } else {
      //   this.showMsgDialog('warning', 'Belum ada file yang diupload', false)
      // }
    },
    readyToDownload(fileLink) {
      window.open(fileLink.file, '_blank')
    },
    unlinkDokumen(fName, pValue) {
      this.loading = true
      const data = {
        module: 'rab',
        file_name: fName
      }
      axios
        .post(`${this.upload}esanqua/procurement/unlink`, data)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.fileNameRab = ''
            if (pValue == undefined) {
              this.removeFileFromDetail(fName)
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (pValue == undefined) {
              if (res.data.status_msg == 'File not found') {
                this.removeFileFromDetail(fName)
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      for (let i = 0; i < this.detail.file.length; i++) {
        if (this.detail.file[i].file.includes(fName)) {
          this.detail.file.splice(i, 1)
        }
      }
      this.updatePhoto(false)
    },
    closeDokumenDialog() {
      setTimeout(() => {
        this.dokumenDialog = false
      }, 300)
    },

    uploadDoc(event) {
      if (event == 'upload') {
        setTimeout(() => {
          this.uploadDialog = true
        }, 500)
      }
      if (event == 'close') {
        if (this.fileNameRab != '') {
          let fName = ''
          fName = this.fileNameRab
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          // this.$refs.uploadDoc.reset()
        }
        this.$refs.entryFormUpload.reset()
        setTimeout(() => {
          this.uploadDialog = false
        }, 500)
      }
      this.fileNameRab = ''
    },
    uploadFileDoc(event) {
      if (event != null) {
        if (event.size <= 1024 * 1024 * 2) {
          this.loading = true
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'rab')
          axios
            .post(`${this.upload}esanqua/procurement`, data)
            .then((res) => {
              if (res.data.status == true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileNameRab = res.data.data.name
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileNameRab = ''
          }, 300)
        }
      } else {
        this.fileNameRab = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload.validate()) {
          self.updatePhoto(true)
        }
      })
    },
    async updatePhoto(isAddFile) {
      const file = []
      if (this.detail.file != null) {
        for (let i = 0; i < this.detail.file.length; i++) {
          const fName = this.detail.file[i].file.slice(
            this.detail.file[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.detail.file[i].subject,
            file: fName
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileNameRab
        })
      }
      const form = {
        id: this.$route.params.id,
        file: file
      }
      this.loading = true
      await axios
        .post(`${this.proc}rab/update_file_upload`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileNameRab = ''
            if (document.getElementById('closeFileUpload') != null) {
              document.getElementById('closeFileUpload').click()
            }
            this.detail.file = []
            setTimeout(() => {
              for (let i = 0; i < file.length; i++) {
                this.detail.file.push({
                  subject: file[i].subject,
                  file: 'http://10.10.20.8:8020/dss/audit/' + file[i].file
                })
              }
              console.log('this.detail.file>>>>', this.detail.file)

              this.getDataFromApi()
            }, 300)
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileNameRab)
          }
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
          this.fileNameRab = ''
        })
      this.isEdit = false
    },
    async deleteAllFile() {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          // this.loading = true
          const arrFileName = []
          for (let i = 0; i < this.detail.file.length; i++) {
            const fileName = this.detail.file[i].file.slice(
              this.detail.file[i].file.lastIndexOf('/') + 1
            )
            const data = {
              module: 'rab',
              file_name: fileName
            }
            await axios
              .post(`${this.uploadApi}esanqua/procurement/unlink`, data)
              .then((res) => {
                console.log(`Unlink-${i + 1}>>>`, res)

                if (res.data.status_code === '00') {
                  arrFileName.push(fileName)
                }
                return null
              })
              .catch((err) => {
                console.log(`Err Unlink-${i + 1}>>>`, err)
                return null
              })
          }
          console.log('deleteAll>>>>>', arrFileName)

          const form = {
            id: this.$route.params.id,
            file: []
          }
          await axios
            .post(`${this.proc}rab/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.dokumenDialog = false
              }, 300)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },

    checkBeforeFetch() {
      if (
        (this.detail.status.id == 0 || this.detail.status.id == 1) &&
        this.getUserProfile != null &&
        this.getUserProfile.employee != null &&
        this.getUserProfile.employee.department != null &&
        (this.getUserProfile.employee.department.id == 3 ||
          this.getUserProfile.employee.department.id == 9 ||
          this.getUserProfile.employee.department.id == 59)
      ) {
        this.getApprovalMatrixDropdown('')
        setTimeout(() => {
          this.selectApprovalDialog = true
        }, 300)
      } else {
        this.fetchMatrix()
      }
    },
    async fetchMatrix() {
      this.loading = true
      const form = {
        id: this.$route.params.id,
        approval_matrix_id: this.approval_matrix_id
      }
      await axios
        .post(`${this.proc}rab/fetch_matrix`, form)
        .then(async (res) => {
          if (res.data.status_code == '00') {
            if (res.data.approval_matrix_result.status_code == '00') {
              this.getDetail()
            } else {
              this.showMsgDialog(
                'warning',
                res.data.approval_matrix_result.status_msg,
                false
              )
            }
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          this.loading = false
          this.showMsgDialog(
            res.data.status_code == '00' ? 'success' : 'warning',
            res.data.status_msg,
            false
          )
          this.selectApprovalDialog = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.selectApprovalDialog = false
        })
    },
    async getApprovalMatrixDropdown(v) {
      this.dropdownApprovalMatrix = []
      const url = `${this.oAuth}approval_matrix/dropdown?keyword=${v}&table_name=tr_budgetplans`
      // url = url + `&company_id=${this.detail.company.id}`
      // url = url + `&department_id=${detail.department.id}`
      // if (this.detail.category_item == 7) {
      // url = url + `&ecatalogue_fpb_category_item=${this.detail.category_item}`
      // }
      axios
        .get(url)
        .then((res) => {
          // console.log('approval matrix>>>', url)
          if (res.data.status_code === '00') {
            return (this.dropdownApprovalMatrix = res.data.data)
          }
          return (this.dropdownApprovalMatrix = [])
        })
        .catch((err) => {
          this.dropdownApprovalMatrix = []
          return console.log(err)
        })
    },
    viewPDF() {
      if (!this.isPdfOpen) {
        this.pdfDialog = true
        this.isPdfOpen = true
        this.countDownTimer()
      }
    },
    countDownTimer() {
      if (this.counter < this.timer) {
        setTimeout(() => {
          this.counter += 1
          this.value += 10
          this.countDownTimer()
        }, 1)
      } else {
        this.showPdf = true
        this.value = 0
        this.counter = 0
      }
    },
    async openHandler(pdfApp) {
      this.info = []
      const info = await pdfApp.pdfDocument
        .getMetadata()
        .catch(console.error.bind(console))

      if (!info) return
      const props = Object.keys(info.info)
      props.forEach((prop) => {
        const obj = {
          name: prop,
          value: info.info[prop]
        }
        this.info.push(obj)
      })
    },
    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = 'page-actual'))
    },
    closePdf() {
      this.pdfDialog = false
      this.isPdfOpen = false
      this.showPdf = false
    },
    closeApprovalDialog() {
      this.selectApprovalDialog = false
      this.approval_matrix_id = null
      this.dropdownApprovalMatrix = []
      this.approvalSearch = null
      this.approvalSelect = null
    },
    nextPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) + 1
        if (this.$route.params.path != 'notification') {
          const xData = this.getRabList.list[pageIndex]
          const path = `/e-catalogue/rab/detail/${xData.id}?idx=${pageIndex}`
          if (this.$route.path !== path) this.$router.push(path)
          setTimeout(() => {
            this.getDetail()
          }, 200)
        } else {
          const xData = this.getNotificationQueue.list[pageIndex]
          if (xData.module === 'rab') {
            // this.$store.commit('setFpbId', pItem.document_id)
            const path = `/e-catalogue/notification/rab/detail/${xData.document_id}?idx=${pageIndex}`
            if (this.$route.path !== path) this.$router.push(path)
            setTimeout(() => {
              this.changeToRead(xData)
              this.getDetail()
            }, 200)
            return null
          } else {
            this.openNotification({ data: xData, idx: pageIndex })
          }
        }
      } catch (e) {
        this.loading = false
      }
    },
    previousPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) - 1
        if (this.$route.params.path != 'notification') {
          const xData = this.getRabList.list[pageIndex]
          const path = `/e-catalogue/rab/detail/${xData.id}?idx=${pageIndex}`
          if (this.$route.path !== path) this.$router.push(path)
          setTimeout(() => {
            this.getDetail()
          }, 200)
        } else {
          const xData = this.getNotificationQueue.list[pageIndex]
          if (xData.module === 'rab') {
            // this.$store.commit('setFpbId', pItem.document_id)
            const path = `/e-catalogue/notification/rab/detail/${xData.document_id}?idx=${pageIndex}`
            if (this.$route.path !== path) this.$router.push(path)
            setTimeout(() => {
              this.changeToRead(xData)
              this.getDetail()
            }, 200)
            return null
          } else {
            this.openNotification({ data: xData, idx: pageIndex })
          }
        }
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
.fontSize12 {
  font-size: 12px;
}
.fs12ml15 {
  font-size: 12px;
  margin-left: 15px;
}
.fs12ml10 {
  font-size: 12px;
  margin-left: 15px;
}
.fs12ml15 {
  font-size: 12px;
  margin-left: 5px;
}
.vPad0 {
  padding: 0;

  .xLabelName {
    margin: 0;
    font-size: 12px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.5);
  }
}
.vPad10 {
  padding: 10px;
}
.vPadX0Y10 {
  padding: 0 10px;
  .vPadProjectTitle {
    margin: 0;
    font-size: 12px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.5);
  }
  .xP0Mt6half {
    padding: 0;
    margin-top: 6.5px;
  }
  .xP0Mt4 {
    padding: 0;
    margin-top: 4px;
  }
}
.vPadMt6 {
  padding: 0;
  margin-top: 6px;
}
.xMargin {
  margin: 0;
}
.xMr10 {
  margin-right: 10px;
}
.xMr5 {
  margin-right: 5px;
}
.xWidth50 {
  width: 50px;
}
.xWidth60 {
  width: 60px;
}
.xWidth70 {
  width: 70px;
}
.xWidth100 {
  width: 100px;
}
.xWidth120 {
  width: 120px;
}
.xWidth150 {
  width: 150px;
}
.xWidth200 {
  width: 200px;
}
.fs12m0 {
  margin: 0;
  font-size: 12px;
}
.rabDetailContainer {
  background: rgba(255, 255, 255, 0.9);
  min-width: 100%;
  min-height: 95vh;
  padding: 10px 20px;
  position: relative;
  .card-title {
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: 60px;
    background: white;
    z-index: 5;
    .card-title-div1 {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }
    .card-title-div2 {
      position: absolute;
      right: 0;
      top: 52px;
      padding: 5px 30px;
      min-width: 200px;
      .card-title-div2-name {
        margin: 0;
        font-size: 16px;
        font-weight: bolder;
        text-transform: uppercase;
      }
    }
  }
  .card-content {
    .toolbarTitle {
      padding: 0;
      text-align: center;
      height: 30px;
      .toolbarTitleDate {
        position: absolute;
        right: 0;
        left: 0;
        top: -20px;
        .date1 {
          font-size: 12px;
          margin: 0 15px;
        }
        .date2 {
          font-size: 12px;
          margin: 0 0 0 15px;
        }
      }
    }
    .rowPaddingY15 {
      padding: 0 15px;
      .prwidh120 {
        position: relative;
        width: 120px;
        .totalItemBudgetInfo {
          font-size: 12px;
          position: absolute;
          top: 25px;
          left: 0;
        }
      }
      .rowColTable {
        margin-top: 10px;
        padding: 0 10px;
      }
    }
    .xTableBorderNCursor {
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .xTableTopSlot {
      border: thin solid rgba(0, 0, 0, 0.12);
      cursor: auto;
      padding: 0 15px;
      height: 75px;
      display: flex;
      overflow: hidden;
      .topSlotButton {
        display: flex;
        align-items: center;
        margin: 0 15px 0 5px;
        .xMargin00310 {
          margin: 0 0 3px 10px;
        }
      }
      .topSlotSearch {
        width: 260px;
        position: relative;
        top: 15px;
        margin: 0 15px 0 5px;
        font-size: 12px;
        height: 45px;
      }
    }
    .toolbarHeaderButton {
      position: absolute;
      left: 0;
      top: 5px;
      z-index: 5;
    }
  }
}
.itemFpbQtySlot {
  width: 150px;
  border: 1px solid darkslategrey;
  padding: 5px;
  border-radius: 3px;
  margin: 0;
  .fpbNoChip {
    margin: 2.5px;
    padding: 0 3px;
    cursor: pointer;
    border: 1px solid rgba(236, 0, 0, 0.5);
  }
}
.actionButton {
  position: relative;
  display: flex;
  // margin-right: 15px;
  // width: 400px;
}
.approvalMatrix {
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
}

.items-total-div-1 {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  min-height: 150px;
  width: 100%;
  justify-content: flex-end;
  padding: 0 10px 0 0;
  .items-total-div-2 {
    // padding: 10px 0;
    width: '40%';
    .items-total-box {
      border: 1px solid #e0e0e0;
      padding: 20px 15px;
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      font-size: 14px;
      div {
        border-bottom: 1px solid #e0e0e0;
        width: 100%;
        padding-top: 5px;
        display: flex;
        p {
          margin: 0;
          margin-right: 10px;
          min-width: 80px;
          position: relative;
          span {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }
  // .items-total-div-3 {
  //   padding: 0 10px;
  //   width: 60%;
  //   font-size: 14px;
  // }
}
@media (max-width: 766px) {
  .actionButton {
    justify-content: center;
    align-items: flex-start;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
  }
  .approvalMatrix {
    margin-bottom: 50px;
  }

  .items-total-div-1 {
    flex-direction: column-reverse;
    .items-total-div-2 {
      width: '100%';
      .items-total-box {
        width: 100%;
      }
    }

    // .items-total-div-3 {
    //   margin-top: 10px;
    //   width: 100%;
    // }
  }
}
</style>
